<template>
  <section
    v-loading="modalLoading"
    class="main-form"
    element-loading-spinner="el-icon-loading"
    element-loading-text="Loading data, please wait..."
  >
    <div
      class="mb-10 mr-10"
      style="
        max-height: 400px;
        max-width: auto;
        overflow-y: scroll;
        scrollbar-width: thin;
      "
    >
      <div class="mr-10">
        <div v-if="addStatsData.type != 'SCHEDULING'">
          <label>Stat Icon</label>
          <el-button
            type="text"
            class="text-center ml-1"
            @click="iconPickerdialogVisible = true"
          >
            <div v-if="isApplicationUser" class="menu-icon">
              <icons
                :iconName="addStatsData.icon ? addStatsData.icon : 'dashboard'"
              ></icons>
            </div>
            <div v-else class="menu-icon">
              <icons
                :iconName="addStatsData.icon ? addStatsData.icon : 'dashboard'"
              ></icons>
            </div>
          </el-button>
        </div>
        <br />
        <label>Component Name</label>
        <el-input
          v-model="addStatsData.component_name"
          placeholder="Enter Component Name"
        ></el-input>
        <div v-if="addStatsData.type == 'STAT'" class="mt-1">
          <label>Data Source:</label>
          <el-select v-model="addStatsData.data_source" style="width: 100%">
            <el-option label="Entities" value="ENTITIES" />
            <el-option label="Form Builders" value="FORM_BUILDERS" />
            <el-option label="Approvals" value="APPROVALS" />
            <el-option label="Third party" value="INTEGRATIONS" />
          </el-select>
        </div>
        <div
          v-if="
            addStatsData.type == 'STAT' &&
            addStatsData.data_source == 'APPROVALS'
          "
          class="mt-1"
        >
          <label>Form Builders</label>
          <el-select
            v-model="addStatsData.selected_approval_formbuilder_ids"
            placeholder="Select A Form Builder"
            style="width: 100%"
            clearable
            multiple
            collapse-tags
            filterable
          >
            <el-option
              v-for="(formbuilder, i) in allFormbuilders"
              :key="formbuilder._id + '_' + i"
              :label="formbuilder.name"
              :value="formbuilder._id"
            ></el-option>
          </el-select>
          <label style="display: block; margin-top: 10px">My Approvals</label>
          <el-select
            v-model="addStatsData.formbuilder_approval_filter"
            placeholder="Select a user filter"
            style="width: 100%"
            class="mb-1"
          >
            <el-option
              label="APPROVAL - Pending Submissions"
              value="PENDING"
            ></el-option>
            <el-option
              label="APPROVAL - Approved Submissions"
              value="APPROVED"
            ></el-option>
            <el-option
              label="APPROVAL - Rejected Submissions"
              value="REJECTED"
            ></el-option>
          </el-select>
        </div>
        <div
          v-if="
            addStatsData.type == 'STAT' &&
            addStatsData.data_source == 'FORM_BUILDERS'
          "
          class="mt-1"
          style="width: 100%; margin-top: 10px"
        >
          <label>Form Builders</label>
          <el-select
            v-model="addStatsData.selected_formbuilder_ids"
            placeholder="Select A Form Builder"
            style="width: 100%"
            clearable
            multiple
            collapse-tags
            filterable
          >
            <el-option label="ALL" value="ALL"></el-option>
            <el-option
              v-for="(formbuilder, i) in allFormbuilders"
              :key="formbuilder._id + '_' + i"
              :label="formbuilder.name"
              :value="formbuilder._id + '#' + formbuilder.code"
              :disabled="isAllOptionSelected"
            ></el-option>
          </el-select>

          <label>Related to</label>
          <el-select
            v-model="addStatsData.selected_relational_entity_ids"
            placeholder="Select relationship"
            style="width: 100%"
            clearable
            multiple
            collapse-tags
            filterable
          >
            <el-option
              v-for="(op, i) in getRelationshipEntities"
              :key="op._id + i"
              :value="op._id"
              :label="op.name"
            >
            </el-option>
          </el-select>

          <label style="display: block; margin-top: 10px">Filters</label>
          <el-select
            v-model="addStatsData.formbuilder_filter"
            placeholder="Select A Filter"
            style="width: 100%"
            :clearable="true"
          >
            <el-option
              v-for="filter in formbuilderFilters"
              :key="filter.value"
              :label="filter.label"
              :value="filter.value"
            />
            <el-option
              :label="
                approvalHoldName
                  ? 'Approval status - ' + approvalHoldName.toUpperCase()
                  : 'Approval status - HOLD'
              "
              value="APPROVAL_HOLD"
            ></el-option>
          </el-select>

          <label style="display: block; margin-top: 10px">Filled By</label>
          <el-select
            v-model="addStatsData.formbuilder_user_filter"
            placeholder="Select a user filter"
            style="width: 100%"
            class="mb-1"
          >
            <el-option label="ALL" value="ALL"></el-option>
            <el-option label="FILLED BY ME" value="FILLED_BY_ME"></el-option>
            <el-option
              label="Filled by Business Contacts"
              value="FILLED_BY_BUSINESS_CONTACTS"
            ></el-option>
          </el-select>
        </div>
        <div
          v-if="
            addStatsData.type == 'STAT' &&
            addStatsData.data_source == 'INTEGRATIONS'
          "
          class="mt-1"
          style="width: 100%; margin-top: 10px"
        >
          <IntegrationConfiguration
            :addStatsData="addStatsData"
            :integrations="integrations"
            :customDashboardData="allDashboardstats"
          >
          </IntegrationConfiguration>
          <!-- <el-checkbox
            v-if="
              addStatsData.event &&
              selectedEvent &&
              addStatsData.display_type !== 'FORMULA' &&
              selectedApplicationDependencies.length
            "
            style="width: 100%; margin-top: 10px"
            v-model="addStatsData.apply_global_filter"
            >Apply dependency filters</el-checkbox
          > -->
        </div>
        <!-- <div
          v-if="
            addStatsData.data_source == 'INTEGRATIONS' &&
            addStatsData.apply_global_filter &&
            selectedApplication
          "
          style="width: 100%; margin-top: 10px"
        >
          <label>Global filters</label>

          <el-select
            v-model="addStatsData.global_filters"
            placeholder="Select filter"
            style="width: 100%"
            :clearable="true"
            multiple
          >
            <el-option
              v-for="option in selectedApplicationDependencies || []"
              :key="option.label + '_' + option.key"
              :label="option.label"
              :value="option.key"
            />
          </el-select>
        </div> -->
        <div
          v-if="addStatsData.data_source == 'INTEGRATIONS'"
          style="width: 100%; margin-top: 10px"
        >
          <label>No of Decimals</label>
          <el-input
            v-model.number="addStatsData.numberValue"
            type="number"
            placeholder="Enter A Number"
          ></el-input>
        </div>
        <div
          style="display: flex"
          v-if="
            addStatsData.type == 'STAT' &&
            addStatsData.data_source !== 'FORM_BUILDERS'
          "
        >
          <el-radio-group
            v-model="addStatsData.display_type"
            @change="showNumberFields"
            class="mt-10 mb-10"
          >
            <el-radio label="count">Show Count</el-radio>
            <el-radio
              label="sum"
              v-if="addStatsData.data_source !== 'INTEGRATIONS'"
              >Show Sum</el-radio
            >
            <el-radio
              label="count_and_sum"
              v-if="addStatsData.data_source == 'ENTITIES'"
              >Show Count & Sum</el-radio
            >
            <el-radio
              label="avg"
              v-if="addStatsData.data_source !== 'INTEGRATIONS'"
              >Show Average</el-radio
            >
            <el-radio label="FORMULA">Show Formula</el-radio>
            <el-radio
              label="MISSING_SLOTS"
              v-if="addStatsData.data_source !== 'INTEGRATIONS'"
              >Show Slots</el-radio
            >
            <el-radio
              label="TIME_STAMP"
              v-if="addStatsData.data_source !== 'INTEGRATIONS'"
            >
              Show Timestamp
            </el-radio>
          </el-radio-group>
        </div>
        <div
          v-if="addStatsData.type == 'STAT'"
          style="display: flex; align-items: center"
        >
          <el-checkbox v-model="addStatsData.isVisible" class="mr-2"
            >Is Visible</el-checkbox
          >
          <label>Background Color:</label>
          <el-color-picker
            size="mini"
            v-model="addStatsData.background_color"
            class="ml-2"
          ></el-color-picker>
          <label class="ml-3">Font Color:</label>
          <el-color-picker
            size="mini"
            v-model="addStatsData.font_color"
            class="ml-2"
          ></el-color-picker>
        </div>
        <div class="d-flex">
          <div
            v-if="
              addStatsData.type == 'STAT' &&
              addStatsData.data_source !== 'FORM_BUILDERS' &&
              addStatsData.data_source !== 'APPROVALS' &&
              addStatsData.display_type !== 'TIME_STAMP'
            "
            style="display: flex; align-items: center"
          >
            <el-checkbox v-model="addStatsData.show_data_in_table"
              >Show Data In Table</el-checkbox
            >
          </div>
          <div class="ml-3" v-if="addStatsData.type == 'STAT'">
            <el-checkbox v-model="addStatsData.enable_Customization"
              >Select Entity Customization</el-checkbox
            >
          </div>
          <div class="ml-3" v-if="addStatsData.type == 'STAT'">
            <el-checkbox v-model="addStatsData.show_full_title"
              >Show full title</el-checkbox
            >
          </div>
        </div>
        <div
          v-if="
            addStatsData.show_data_in_table &&
            addStatsData.availableColumns &&
            addStatsData.availableColumns.length
          "
          class="available-columns"
        >
          <p>Select Columns To Display:</p>
          <el-select
            v-model="addStatsData.selectedColumns"
            multiple
            placeholder="Select columns"
            style="width: 100%"
          >
            <el-option
              v-for="column in addStatsData.availableColumns"
              :key="column.key"
              :label="column.label"
              :value="column.key"
            ></el-option>
          </el-select>
        </div>

        <div v-if="addStatsData.type == 'ENTITY_VIEW'">
          <label>Entity Views</label>
          <el-select
            clearable
            filterable
            v-model="addStatsData.entity_view_id"
            style="width: 100%"
            @change="autoFillComponentName"
          >
            <el-option
              v-for="(view, index) in getAllEntityViews.data || []"
              :key="index"
              :label="view.name"
              :value="view._id"
            >
            </el-option>
          </el-select>
        </div>
        <div v-if="addStatsData.type == 'SCHEDULING'">
          <h4 class="mt-1">Scheduling Entity</h4>
          <el-select
            v-model="addStatsData.scheduler_entity"
            no-data-text="No Entities available"
            filterable
            default-first-option
            @change="
              (value) => {
                getEntityFields(value, 'SCHEDULER');
                fetchSchedulerEntityFilters(value);
              }
            "
          >
            <el-option
              v-for="(entity, index) of getAllEntitiesData"
              :value="entity._id"
              :key="index"
              :label="entity.name"
            >
              <span style="float: left">{{ entity.name }}</span>
            </el-option>
          </el-select>
          <template v-if="addStatsData.scheduler_entity">
            <el-checkbox
              v-if="
                isEntityDashboard &&
                getRelationshipEntities.find(
                  (e) => e._id == addStatsData.scheduler_entity
                )
              "
              v-model="addStatsData.applyRelationship"
              >Apply Relationships</el-checkbox
            >
            <h4>Task Date</h4>
            <el-select
              v-model="addStatsData.scheduler_entity_date_field"
              no-data-text="No Date Fields Available"
              filterable
              default-first-option
            >
              <el-option
                v-for="(field, index) of schedulingEntityFields.filter((e) =>
                  ['DATE', 'DATE_TIME', 'DATE_RANGE'].includes(e.inputType)
                )"
                :value="field.template_key"
                :key="index + 'date_field'"
                :label="field.label"
              >
              </el-option>
            </el-select>
            <h4>Resource Entity</h4>
            <el-select
              v-model="addStatsData.resource_entity"
              no-data-text="No Entities available"
              filterable
              default-first-option
              @change="
                (value) =>
                  getEntityFields(
                    schedulingEntityFields.find((e) => e.template_key == value)
                      .entity_id,
                    'RESOURCE'
                  )
              "
            >
              <el-option
                v-for="(field, index) of schedulingEntityFields.filter((e) =>
                  ['ENTITY'].includes(e.inputType)
                )"
                :value="field.template_key"
                :key="index + 'entity_field'"
                :label="field.label"
              >
              </el-option>
            </el-select>
            <template v-if="addStatsData.resource_entity">
              <h4 class="mt-1">Job Entity</h4>
              <el-select
                v-model="addStatsData.job_entity"
                no-data-text="No Entities available"
                filterable
                default-first-option
                @change="
                  (value) =>
                    getEntityFields(
                      schedulingEntityFields.find(
                        (e) => e.template_key == value
                      ).entity_id,
                      'JOB'
                    )
                "
              >
                <el-option
                  v-for="(field, index) of schedulingEntityFields.filter(
                    (e) =>
                      ['ENTITY'].includes(e.inputType) &&
                      e.template_key !== addStatsData.resource_entity
                  )"
                  :value="field.template_key"
                  :key="index + 'entity_field'"
                  :label="field.label"
                >
                </el-option>
              </el-select>
            </template>
            <template v-if="addStatsData.resource_entity">
              <h4>Resource Time</h4>
              <el-select
                v-model="addStatsData.resource_entity_time_field"
                no-data-text="No hours fields available"
                filterable
                default-first-option
              >
                <el-option
                  v-for="(field, index) of resourceEntityFields.filter((e) =>
                    ['FORMULA', 'NUMBER'].includes(e.inputType)
                  )"
                  :value="field.template_key"
                  :key="index + 'date_field'"
                  :label="field.label"
                >
                </el-option>
              </el-select>
            </template>
            <template v-if="addStatsData.job_entity">
              <h4>Job Time</h4>
              <el-select
                v-model="addStatsData.job_entity_time_field"
                no-data-text="No hours fields available"
                filterable
                default-first-option
              >
                <el-option-group label="Job">
                  <el-option
                    v-for="(field, index) of jobEntityFields.filter((e) =>
                      ['FORMULA', 'NUMBER'].includes(e.inputType)
                    )"
                    :value="field.template_key"
                    :key="index + 'date_field'"
                    :label="field.label"
                  >
                  </el-option>
                </el-option-group>
                <el-option-group label="Schedule">
                  <el-option
                    v-for="(field, index) of schedulingEntityFields.filter(
                      (e) => ['FORMULA', 'NUMBER'].includes(e.inputType)
                    )"
                    :value="field.template_key + '@SCHEDULE'"
                    :key="index + 'date_field'"
                    :label="field.label"
                  >
                  </el-option>
                </el-option-group>
              </el-select>
              <h4>Label For Resource</h4>
              <el-select
                v-model="addStatsData.scheduler_entity_resource_label_field"
                no-data-text="No fields available"
                filterable
                default-first-option
                multiple
                collapse-tags
              >
                <el-option
                  v-for="(field, index) of schedulingEntityFields"
                  :value="field.template_key"
                  :key="index + 'resource_field'"
                  :label="field.label"
                >
                </el-option>
              </el-select>
              <h4>Label For Job</h4>
              <el-select
                v-model="addStatsData.scheduler_entity_job_label_date_field"
                no-data-text="No fields available"
                filterable
                default-first-option
                multiple
                collapse-tags
              >
                <el-option
                  v-for="(field, index) of schedulingEntityFields"
                  :value="field.template_key"
                  :key="index + 'resource_field'"
                  :label="field.label"
                >
                </el-option>
              </el-select>
            </template>
            <template>
              <h4 class="mt-2">Scheduler Filters</h4>
              <el-select
                v-model="addStatsData.scheduler_entity_filter"
                v-if="addStatsData.scheduler_entity"
                filterable
                clearable
                placeholder="Select Filters"
              >
                <el-option
                  v-for="(filter, index) in schedulerEntityFilters.filter(
                    (f) => !f.parent_filter_id
                  )"
                  :key="index"
                  :label="filter.filter_name"
                  :value="filter._id"
                />
              </el-select>
            </template>
            <template
              v-if="
                addStatsData.scheduler_entity && addStatsData.resource_entity
              "
            >
              <h4>Scheduling Sub-group</h4>
              <el-select
                v-model="addStatsData.scheduler_entity_sub_groups"
                no-data-text="No entity fields available"
                filterable
                default-first-option
                collapse-tags
                multiple
                @change="fetchSubGroupFilters"
              >
                <el-option
                  v-for="(field, index) of schedulingEntityFields.filter(
                    (e) =>
                      ['ENTITY'].includes(e.inputType) &&
                      e.template_key !== addStatsData.resource_entity &&
                      e.template_key !== addStatsData.job_entity
                  )"
                  :value="field.template_key"
                  :key="index + 'date_field'"
                  :label="field.label"
                >
                </el-option>
              </el-select>
              <template
                v-if="
                  addStatsData.scheduler_entity_sub_groups &&
                  addStatsData.scheduler_entity_sub_groups.length
                "
              >
                <h4>Divide Sub-groups By</h4>
                <el-select
                  v-model="addStatsData.scheduler_entity_sub_groups_filters"
                  filterable
                  default-first-option
                  collapse-tags
                  multiple
                >
                  <el-option-group
                    v-for="entity of schedulerEntitySubGroupsData"
                    :key="entity.entity_id + '_sgf'"
                    :label="entity.label"
                  >
                    <el-option
                      v-for="filter of entity.filters"
                      :key="'_sgf_' + filter._id"
                      :value="entity.key + '@' + filter._id"
                      :label="filter.filter_name"
                    >
                    </el-option>
                  </el-option-group>
                </el-select>
              </template>
              <template v-if="addStatsData.scheduler_entity">
                <el-link
                  :underline="false"
                  type="primary"
                  @click="openColorRulesDialog"
                  style="display: block; margin-top: 5px"
                  >Color Rules</el-link
                >
              </template>
            </template>
          </template>
        </div>
        <template v-if="addStatsData.display_type == 'FORMULA'">
          <div v-if="!refreshFormula">
            <h4 class="f-weight-500 h4 mt-15 mb-05">Art Board</h4>
            <div class="artboard">
              <div
                v-for="(item, index) of addStatsData.selected_fields"
                v-bind:key="index"
              >
                <el-button
                  v-if="showFieldButton(item.type)"
                  size="medium"
                  class="btn-variable"
                  @click="swapFields(index)"
                  :class="getActiveClass(index)"
                >
                  <span v-if="item.type == 'OPERATOR'">{{
                    item.operator
                  }}</span>

                  <span v-if="item.type == 'FIELD'">{{ item.field_name }}</span>
                  <span v-if="item.type == 'PARENTHESES'">{{
                    item.parentheses
                  }}</span>
                  <span v-if="item.type == 'FORMULA'">{{ item.formula }}</span>
                  <span v-if="item.type == 'NUMBER'">{{ item.number }}</span>
                  <span v-if="item.type == 'CURRENCY'">{{
                    item.currency
                  }}</span>
                  <span v-if="item.type == 'DATE'">{{ item.date }}</span>
                  <span v-if="item.type == 'TIME'">{{ item.time }}</span>
                  <span v-if="item.type == 'DATE_TIME_RANGE'">{{
                    item.date_time_range
                  }}</span>
                  <span v-if="item.type == 'DATE_RANGE'">{{
                    item.date_range
                  }}</span>
                  <span v-if="item.type == 'LIST'">{{ item.list }}</span>
                  <span v-if="item.type == 'GLOBAL_VARIABLE'">{{
                    item.field_name
                  }}</span>
                </el-button>
                <el-button
                  v-if="item.type == 'OPERATOR'"
                  :type="getOperationType(item.operator)"
                  size="mini"
                  class="btn-operation"
                  @click="swapFields(index)"
                  circle
                  :class="getActiveClass(index)"
                >
                  <img
                    v-if="item.operator == '+'"
                    src="@/assets/img/calculator/plus.svg"
                    alt="brackets-left"
                  />
                  <img
                    v-if="item.operator == '-'"
                    src="@/assets/img/calculator/minus.svg"
                    alt="brackets-left"
                  />
                  <img
                    v-if="item.operator == '*'"
                    src="@/assets/img/calculator/close.svg"
                    alt="brackets-left"
                  />
                  <img
                    v-if="item.operator == '/'"
                    src="@/assets/img/calculator/divider.svg"
                    alt="brackets-left"
                  />
                </el-button>
                <el-button
                  v-if="item.type == 'PARENTHESES' && item.parentheses == '('"
                  type="text"
                  effect="dark"
                  class="text-button"
                  >(</el-button
                >
                <el-button
                  v-if="item.type == 'PARENTHESES' && item.parentheses == ')'"
                  type="text"
                  effect="dark"
                  class="text-button"
                  >)</el-button
                >
              </div>
            </div>
            <div>
              <div class="variables-fields">
                <el-form>
                  <el-row :gutter="10">
                    <el-col :md="12" :sm="12" :lg="8">
                      <el-form-item label="Fields">
                        <el-select
                          v-model="showSelectField"
                          :disabled="checkDisabled('field')"
                          @change="onSelectField"
                          placeholder="Select Fields"
                        >
                          <el-option
                            v-for="item of getFields"
                            :key="item.keyValue"
                            :label="item.component_name"
                            :value="item.keyValue"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <!-- <el-col :md="12" :sm="12" :lg="8">
                      <el-form-item label="Global Variable">
                        <el-select
                          v-model="showSelectGlobalVariable"
                          @change="onSelectGlobalVariable($event)"
                          placeholder="Select Global variable"
                          :disabled="checkDisabled('global_variable')"
                        >
                          <el-option
                            v-for="item of getGlobalVariables()"
                            :key="item.label"
                            :label="item.label"
                            :value="item.label"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col> -->

                    <el-col :md="12" :sm="12" :lg="8">
                      <el-form-item label="Numbers">
                        <el-input
                          v-model="manualNumber"
                          placeholder="Enter Number"
                          :disabled="checkDisabled('number')"
                        >
                          <el-button
                            slot="append"
                            type="primary"
                            icon="el-icon-plus"
                            @click="addNumber"
                            :disabled="manualNumber < 0"
                          ></el-button>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div class="operaters">
                <el-button-group class="arthimetic-opeations">
                  <el-button
                    type="success"
                    @click="onSelectOperator('+')"
                    class="btn-operation"
                    size="mini"
                    :disabled="checkDisabled('operator')"
                  >
                    <img
                      src="@/assets/img/calculator/plus.svg"
                      alt="brackets-left"
                    />
                  </el-button>
                  <el-button
                    type="primary"
                    @click="onSelectOperator('-')"
                    class="btn-operation"
                    size="mini"
                    :disabled="checkDisabled('operator')"
                  >
                    <img
                      src="@/assets/img/calculator/minus.svg"
                      alt="brackets-left"
                    />
                  </el-button>
                  <el-button
                    type="info"
                    @click="onSelectOperator('*')"
                    class="btn-operation"
                    size="mini"
                    :disabled="checkDisabled('operator')"
                  >
                    <img
                      src="@/assets/img/calculator/close.svg"
                      alt="brackets-left"
                    />
                  </el-button>
                  <el-button
                    type="warning"
                    @click="onSelectOperator('/')"
                    class="btn-operation"
                    size="mini"
                    :disabled="checkDisabled('operator')"
                  >
                    <img
                      src="@/assets/img/calculator/divider.svg"
                      alt="brackets-left"
                    />
                  </el-button>
                </el-button-group>
                <el-button-group class="brackets-btn-group">
                  <el-button
                    type="info"
                    @click="onSelectParentheses('(')"
                    class="btn-operation"
                    size="mini"
                    :disabled="checkDisabled('parentheses', '(')"
                    >(</el-button
                  >
                  <el-button
                    type="info"
                    @click="onSelectParentheses(')')"
                    class="btn-operation"
                    size="mini"
                    :disabled="checkDisabled('parentheses', ')')"
                    >)</el-button
                  >

                  <el-button
                    type="danger"
                    @click="popField()"
                    class="btn-operation"
                    size="mini"
                    :disabled="
                      addStatsData &&
                      addStatsData.selected_fields &&
                      addStatsData.selected_fields.length < 1
                        ? true
                        : false
                    "
                  >
                    <i class="el-icon-delete"></i>
                  </el-button>
                </el-button-group>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            v-if="
              !selectedEntityRelationalData &&
              !selectedEntityNestedRelationalData &&
              addStatsData.type !== 'ENTITY_VIEW' &&
              addStatsData.type !== 'SCHEDULING' &&
              addStatsData.data_source !== 'FORM_BUILDERS' &&
              addStatsData.data_source !== 'APPROVALS' &&
              addStatsData.data_source !== 'INTEGRATIONS'
            "
            class="mt-1 mb-0"
          >
          <label
            v-if="
              addStatsData.type == 'CHART'
            "
            >Chart Description</label
          >
          <el-input v-model="addStatsData.chart_description"
          placeholder="Enter Description">
          </el-input>
            <label>Entities</label>
            <el-select
              v-model="addStatsData.entity_id"
              no-data-text="No Entities Available"
              filterable
              clearable
              default-first-option
              @change="getComponentInfo"
              style="width: 100%"
              placeholder="Entity"
            >
              <el-option
                v-for="(entity, index) of getAllEntitiesData"
                :value="entity._id"
                :key="index"
                :label="entity.name"
              >
                <span style="float: left">{{ entity.name }}</span>
              </el-option>
            </el-select>
            <el-select
              placeholder="Group By"
              v-model="addStatsData.stat_field_group_by"
              v-if="
                addStatsData.type == 'STAT' &&
                !['MISSING_SLOTS', 'TIME_STAMP'].includes(
                  addStatsData.display_type
                )
              "
              clearable
              style="width: 100%"
              class="mt-1"
              filterable
            >
              <el-option
                v-for="(field, index) of getTemplateFields.filter(
                  (e) => e.inputType !== 'DATE'
                )"
                :value="field.key"
                :key="field.key + index"
                :label="`${field.template_name} - ${field.label} `"
              >
                <span>{{ field.template_name }} - {{ field.label }}</span>
              </el-option>
            </el-select>
            <el-select
              placeholder="Group By"
              v-model="addStatsData.table_field_group_by"
              v-if="addStatsData.type == 'TABLE'"
              clearable
              @change="getSelectedFieldOptions"
              style="width: 100%"
              class="mt-1"
            >
              <el-option
                v-for="(field, index) of getTemplateFields"
                :value="field.key"
                :key="field.key + index"
                :label="`${field.template_name} - ${field.label} `"
              >
                <span>{{ field.template_name }} - {{ field.label }}</span>
              </el-option>
            </el-select>
            <el-select
              placeholder="Sub Group By"
              v-model="addStatsData.table_field_sub_group_by"
              v-if="addStatsData.type == 'TABLE'"
              clearable
              @change="getSelectedFieldOptions"
              style="width: 100%"
              class="mt-1 mb-1"
            >
              <el-option
                v-for="(field, index) of getTemplateFields.filter(
                  (e) =>
                    e.input_type != 'MULTI_SELECT' &&
                    e.key != addStatsData.table_field_group_by
                )"
                :value="field.key"
                :key="field.key + index"
                :label="`${field.template_name} - ${field.label} `"
              >
                <span>{{ field.template_name }} - {{ field.label }}</span>
              </el-option>
            </el-select>
            <el-checkbox
              v-if="addStatsData.type == 'TABLE'"
              v-model="addStatsData.ShowExport"
              class="mb-1"
              >Show Export In Table
            </el-checkbox>
            <el-select
              placeholder="Select options to group"
              multiple
              v-model="addStatsData.table_field_group_by_selected_options"
              v-if="addStatsData.table_field_sub_group_by"
              :clearable="true"
              class="mt-1"
              collapse-tags
              style="width: 100%"
            >
              <template
                v-if="
                  checkFieldType(
                    addStatsData.table_field_sub_group_by,
                    'ENTITY'
                  )
                "
              >
                <el-option
                  v-for="(data, index) of groupByFieldEntityValues"
                  :key="index + 'entity' + data._id"
                  :value="data._id"
                  :label="getLabel(data, index, groupByFieldEntity)"
                >
                  <span>{{ getLabel(data, index, groupByFieldEntity) }}</span>
                </el-option>
              </template>
              <template v-else>
                <el-option
                  v-for="(option, index) of pieChartFieldGroupByOptions"
                  :value="option"
                  :key="index"
                  :label="option"
                >
                  <span>{{ option }}</span>
                </el-option>
              </template>
            </el-select>
            <div v-if="addStatsData.table_field_group_by" class="mt-1">
              <el-tag
                v-for="(
                  field, index
                ) in addStatsData.table_field_group_by_fields"
                :key="index + 'name'"
                @close="handleClose(index)"
                style="margin-right: 5px; margin-top: 5px"
                :type="field && field.sub_group ? 'success' : 'primary'"
              >
                {{ field.name }}
              </el-tag>
              <!-- :closable="
                !addStatsData.table_field_group_by_fields ||
                !addStatsData.table_field_group_by_fields.length ||
                (addStatsData.table_field_group_by_fields &&
                  addStatsData.table_field_group_by_fields.length == 1)
                  ? false
                  : true
              " -->
              <el-link
                icon="el-icon-circle-plus-outline"
                :underline="false"
                type="primary"
                style="margin-left: 3px"
                @click="openTableColums"
              ></el-link>
            </div>
          </div>
          <div
            v-if="
              (isFromApplicationuser || selectedEntityRelationalData) &&
              !selectedEntityNestedRelationalData &&
              addStatsData.data_source !== 'FORM_BUILDERS' &&
              addStatsData.data_source !== 'APPROVALS'
            "
          >
            <label>Relational entities</label>
            <el-select
              placeholder="Relational Entity"
              v-model="selectedEntityRelationalData"
              @change="getComponentInfo"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="(op, i) in getRelationshipEntities"
                :key="op._id + i"
                :value="op._id"
                :label="op.name"
                >{{ "My " + op.name }}</el-option
              >
            </el-select>
          </div>
          <div
            v-if="
              isFromApplicationuser &&
              !selectedEntityRelationalData &&
              addStatsData.data_source !== 'FORM_BUILDERS' &&
              addStatsData.data_source !== 'APPROVALS'
            "
            class="mt-1"
          >
            <label>Nested relational entities</label>
            <el-select
              placeholder="Nested Relational Entity"
              v-model="selectedEntityNestedRelationalData"
              @change="getComponentInfo"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="(op, i) in getNestedRelationshipEntities"
                :key="op.key + i"
                :value="op.key"
                :label="op.name"
              ></el-option>
            </el-select>
          </div>
          <div
            v-if="
              addStatsData.type == 'STAT' &&
              addStatsData.display_type == 'MISSING_SLOTS'
            "
          >
            <el-select
              placeholder="Start date"
              v-model="addStatsData.start_date"
              clearable
              style="width: 100%"
              class="mt-1"
              filterable
            >
              <el-option
                v-for="(field, index) of getTemplateFields.filter(
                  (e) => e.inputType == 'DATE'
                )"
                :value="field.key"
                :key="field.key + index"
                :label="`${field.template_name} - ${field.label} `"
              >
                <span>{{ field.template_name }} - {{ field.label }}</span>
              </el-option>
            </el-select>
            <el-select
              placeholder="Frequency"
              v-model="addStatsData.frequency"
              v-if="addStatsData.start_date"
              clearable
              style="width: 100%"
              class="mt-1"
              filterable
            >
              <el-option
                v-for="(field, index) of getTemplateFields.filter((e) =>
                  ['NUMBER', 'LIST'].includes(e.inputType)
                )"
                :value="field.key"
                :key="field.key + index"
                :label="`${field.template_name} - ${field.label} `"
              >
                <span>{{ field.template_name }} - {{ field.label }}</span>
              </el-option>
            </el-select>
            <el-select
              placeholder="Columns"
              v-model="addStatsData.columns"
              clearable
              style="width: 100%"
              class="mt-1"
              filterable
              multiple
              collapse-tags
            >
              <el-option
                v-for="(field, index) of getTemplateFields"
                :value="field.key"
                :key="field.key + index"
                :label="`${field.template_name} - ${field.label} `"
              >
                <span>{{ field.template_name }} - {{ field.label }}</span>
              </el-option>
            </el-select>
            <el-select
              placeholder="Select other entities"
              v-model="addStatsData.other_entity_id"
              style="width: 100%"
              class="mt-1"
              filterable
              clearable
              loading-text="Loading..."
              :loading="otherEntitiesLoading"
              @change="getOtherEntityFields"
            >
              <el-option-group label="As Fields">
                <el-option
                  v-for="field in getEntityFieldRelatedEntities"
                  :key="'field' + field.key"
                  :value="field.key"
                  :label="field.label"
                >
                </el-option>
              </el-option-group>
            </el-select>
            <el-select
              placeholder="Date field"
              v-model="addStatsData.other_entity_date"
              v-if="addStatsData.start_date && addStatsData.other_entity_id"
              clearable
              style="width: 100%"
              class="mt-1"
              filterable
            >
              <el-option
                v-for="(field, index) of otherEntityFields.filter(
                  (e) => e.inputType == 'DATE'
                )"
                :value="field.key"
                :key="field.key + index"
                :label="`${field.template_name} - ${field.label} `"
              >
                <span>{{ field.template_name }} - {{ field.label }}</span>
              </el-option>
            </el-select>
          </div>
          <label
            v-if="
              addStatsData.type == 'CHART' &&
              addStatsData.chart_type != 'COMBINATION'
            "
            >Chart type</label
          >
          <el-select
            v-model="addStatsData.chart_type"
            filterable
            default-first-option
            class="mb-1"
            v-if="
              addStatsData.type == 'CHART' &&
              addStatsData.chart_type != 'COMBINATION'
            "
            style="width: 100%"
          >
            <el-option
              v-for="(field, index) of chartTypes"
              :value="field.value"
              :key="field.value + index"
              :label="field.label"
            >
              <span>{{ field.label }}</span>
            </el-option>
          </el-select>
          <div
            v-if="
              addStatsData.type == 'CHART' && addStatsData.chart_type === 'BAR'
            "
            class="mt-2"
          >
            <h4>Bar Orientation</h4>
            <el-radio-group v-model="addStatsData.barOrientation">
              <el-radio-button label="vertical">Vertical</el-radio-button>
              <el-radio-button label="horizontal">Horizontal</el-radio-button>
            </el-radio-group>
          </div>
          <div v-if="addStatsData.type == 'CHART'" class="mt-2">
            <el-checkbox
              v-model="addStatsData.isCustomization"
              @change="onCustomizationChange"
            >
              Select Customization
            </el-checkbox>
            <div v-if="addStatsData.isCustomization" style="margin-top: 10px">
              <el-select
                v-model="addStatsData.selectedCustomization"
                placeholder="Select Customization"
                filterable
                clearable
                :loading="loading"
                style="width: 100%"
              >
                <el-option
                  v-for="item in chartscustomizationOptions"
                  :key="item._id"
                  :label="item.label"
                  :value="item._id"
                />
              </el-select>
            </div>
          </div>
          <label v-if="addStatsData.type == 'CHART'">Select field</label>
          <el-select
            v-model="addStatsData.pie_chart_field"
            filterable
            default-first-option
            class="mb-1"
            v-if="addStatsData.type == 'CHART'"
            style="width: 100%"
            @change="fetchFieldOptionsForChart(addStatsData.pie_chart_field)"
          >
            <el-option
              v-for="(field, index) of getTemplateFields"
              :value="field.key"
              :key="field.key + index"
              :label="`${field.template_name} - ${field.label}`"
            >
              <span>{{ field.template_name }} - {{ field.label }}</span>
            </el-option>
          </el-select>
          <label
            v-if="addStatsData.type == 'CHART' && addStatsData.pie_chart_field"
            >Select Options</label
          >
          <el-select
            placeholder="Select options for chart"
            multiple
            v-model="addStatsData.pie_chart_field_options"
            v-if="addStatsData.pie_chart_field"
            :clearable="true"
            collapse-tags
            style="width: 100%"
            @change="addStatsData.type === 'BAR' ? optionsChanged : () => {}"
          >
            <template
              v-if="checkFieldType(addStatsData.pie_chart_field, 'ENTITY')"
            >
              <el-option
                v-for="(data, index) of pieChartFieldEntityValues"
                :key="index + 'entity' + data._id"
                :value="data._id"
                :label="getLabel(data, index, pieChartFieldEntity)"
              >
                <span>{{ getLabel(data, index, pieChartFieldEntity) }}</span>
              </el-option>
            </template>
            <template v-else>
              <el-option
                v-for="(option, index) of pieChartFieldSelectOptions"
                :value="option"
                :key="index"
                :label="option"
              >
                <span>{{ option }}</span>
              </el-option>
            </template>
          </el-select>
          <div
            v-if="
              addStatsData.chart_type == 'BAR' && addStatsData.pie_chart_field
            "
          >
            <el-collapse>
              <el-collapse-item>
                <template slot="title">
                  Selected Options Color Coding
                </template>
                <div>
                  <el-scrollbar class="elementScroll">
                    <table
                      class="table table-striped"
                      style="z-index: 1000; border: 10px; margin: 2px 0px"
                    >
                      <tr>
                        <td
                          v-for="(
                            op, i
                          ) in addStatsData.pie_chart_field_options"
                          :key="op"
                        >
                          <el-color-picker
                            size="mini"
                            v-model="
                              addStatsData.pie_chart_field_options_colors[i]
                            "
                          ></el-color-picker>
                          <p style="font-size: 10px">
                            {{
                              checkFieldType(
                                addStatsData.pie_chart_field,
                                "ENTITY"
                              )
                                ? getOptionLabel(op)
                                : op
                            }}
                          </p>
                        </td>
                      </tr>
                    </table>
                  </el-scrollbar>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <label v-if="addStatsData.type == 'CHART'">Filter</label>
          <!-- chartFilters -->
          <el-select
            v-if="addStatsData.type == 'CHART'"
            placeholder="Select filter"
            clearable
            v-model="addStatsData.chart_selected_filter"
            style="width: 100%"
          >
            <el-option
              v-for="fl in chartFilters.filter((e) => !e.parent_filter_id)"
              :key="fl._id"
              :value="fl._id"
              :label="fl.filter_name"
            ></el-option>
          </el-select>
          <label
            v-if="
              addStatsData.type == 'CHART' &&
              (!addStatsData.sum_fields ||
                !addStatsData.sum_fields.length ||
                addStatsData.sum_fields.length == 1) &&
              addStatsData.chart_type != 'COMBINATION'
            "
            >Group By</label
          >
          <el-select
            placeholder="Group By"
            v-model="addStatsData.pie_chart_field_group_by"
            :clearable="true"
            v-if="
              addStatsData.type == 'CHART' &&
              (!addStatsData.sum_fields ||
                !addStatsData.sum_fields.length ||
                addStatsData.sum_fields.length == 1) &&
              addStatsData.chart_type != 'COMBINATION'
            "
            @change="getSelectedFieldOptions"
            style="width: 100%"
          >
            <el-option
              v-for="(field, index) of getTemplateFields.filter(
                (e) => e.key != addStatsData.pie_chart_field
              )"
              :value="field.key"
              :key="field.key + index"
              :label="`${field.template_name} - ${field.label} `"
            >
              <span>{{ field.template_name }} - {{ field.label }}</span>
            </el-option>
          </el-select>
          <!-- include_chart_total -->
          <el-checkbox
            v-model="addStatsData.include_chart_total"
            v-if="addStatsData.pie_chart_field_group_by"
          >
            Include total
          </el-checkbox>
          <el-select
            placeholder="Select Options To Group"
            multiple
            v-model="addStatsData.pie_chart_field_group_by_selected_options"
            v-if="addStatsData.pie_chart_field_group_by"
            :clearable="true"
            class="mt-1"
            collapse-tags
            style="width: 100%"
          >
            <template
              v-if="
                checkFieldType(addStatsData.pie_chart_field_group_by, 'ENTITY')
              "
            >
              <el-option
                v-for="(data, index) of groupByFieldEntityValues"
                :key="index + 'entity' + data._id"
                :value="data._id"
                :label="getLabel(data, index, groupByFieldEntity)"
              >
                <span>{{ getLabel(data, index, groupByFieldEntity) }}</span>
              </el-option>
            </template>
            <template v-else>
              <el-option
                v-for="(option, index) of pieChartFieldGroupByOptions"
                :value="option"
                :key="index"
                :label="option"
              >
                <span>{{ option }}</span>
              </el-option>
            </template>
          </el-select>
          <template
            v-if="
              addStatsData.type == 'CHART' &&
              addStatsData.chart_type == 'COMBINATION'
            "
          >
            <el-row>
              <el-col :span="12">
                <label>Show total</label>
              </el-col>
              <el-col :span="8">
                <label>Select Type</label>
              </el-col>
            </el-row>
            <el-row v-for="(row, index) in rows" :key="index">
              <el-col :span="12">
                <el-select
                  v-model="row.sum_field"
                  placeholder="Total Field"
                  class="mb-1"
                  clearable
                >
                  <el-option
                    v-for="(field, fieldIndex) in getTotalFields"
                    :value="field.key"
                    :key="field.key + fieldIndex"
                    :label="`${field.template_name} - ${field.label} `"
                    :disabled="
                      isOptionDisabled(row.sum_field, field.key, index)
                    "
                  >
                    <span>{{ field.template_name }} - {{ field.label }}</span>
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select
                  v-model="row.chart_type"
                  filterable
                  default-first-option
                  class="mb-1"
                >
                  <el-option
                    v-for="(field, fieldIndex) in subChartTypes"
                    :value="field.value"
                    :key="field.value + fieldIndex"
                    :label="field.label"
                  >
                    <span>{{ field.label }}</span>
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="1">
                <el-link
                  :underline="false"
                  type="primary"
                  style="margin-left: 3px"
                  @click="addRow"
                >
                  <i class="el-icon-circle-plus"></i>
                </el-link>
              </el-col>
              <el-col :span="1">
                <el-link
                  :underline="false"
                  type="primary"
                  style="margin-left: 3px"
                  @click="removeRow(index)"
                >
                  <i class="el-icon-remove"></i>
                </el-link>
              </el-col>
            </el-row>
          </template>
          <template v-else>
            <label v-if="addStatsData.type == 'CHART'">Show total</label>
            <el-select
              v-model="addStatsData.sum_fields"
              v-if="addStatsData.type == 'CHART'"
              placeholder="Total field"
              clearable
              :multiple="true"
              :multiple-limit="addStatsData.pie_chart_field_group_by ? 1 : null"
              collapse-tags
              style="width: 100%"
            >
              <el-option
                v-for="(field, index) of getTotalFields"
                :value="field.key"
                :key="field.key + index"
                :label="`${field.template_name} - ${field.label} `"
              >
                <span>{{ field.template_name }} - {{ field.label }}</span>
              </el-option>
            </el-select>
            <div
              class="mt-1"
              style="display: flex"
              v-if="
                addStatsData.type == 'CHART' &&
                addStatsData.chart_type == 'BAR' &&
                addStatsData.sum_fields.length <= 1
              "
            >
              <label style="margin-right: 8px">Select color</label>
              <el-color-picker
                v-model="addStatsData.BarColor"
                class="flex-item"
                size="mini"
              ></el-color-picker>
            </div>
            <el-checkbox
              v-model="addStatsData.isStacked"
              v-if="
                addStatsData.type == 'CHART' &&
                addStatsData.chart_type == 'BAR' &&
                addStatsData.sum_fields.length > 1
              "
              class="mt-1 mr-1"
              >Stacked</el-checkbox
            >
            <el-switch
              size="mini"
              v-if="
                addStatsData.isStacked && addStatsData.sum_fields.length > 1
              "
              v-model="addStatsData.startFrom"
              :active-value="true"
              :inactive-value="false"
            ></el-switch>
            <span
              v-if="
                addStatsData.isStacked && addStatsData.sum_fields.length > 1
              "
              >Start From 0</span
            >
          </template>
          <div v-if="addStatsData.enable_Customization" class="mt-3 mb-3">
            <el-table :data="tableData" border>
              <el-table-column prop="label" label="Label"></el-table-column>
              <el-table-column
                prop="entityName"
                label="Entity Name"
              ></el-table-column>
              <el-table-column label="Select Customization">
                <template #default="{ row }">
                  <el-select
                    v-model="row.selectedCustomization"
                    placeholder="Select Customization"
                    filterable
                    clearable
                    @change="handleCustomizationChange(row, $event)"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="option in row.customizations"
                      :key="option._id"
                      :value="option._id"
                      :label="option.label"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <label
            v-if="
              !['CHART', 'ENTITY_VIEW', 'SCHEDULING'].includes(
                addStatsData.type
              ) &&
              addStatsData.data_source !== 'FORM_BUILDERS' &&
              addStatsData.data_source !== 'APPROVALS' &&
              addStatsData.data_source !== 'INTEGRATIONS' &&
              addStatsData.display_type !== 'TIME_STAMP'
            "
            >Filters</label
          >
          <el-select
            v-model="addStatsData.filter_id"
            no-data-text="No Filters Available"
            filterable
            default-first-option
            class="mb-1"
            v-if="
              !['CHART', 'ENTITY_VIEW', 'SCHEDULING'].includes(
                addStatsData.type
              ) &&
              addStatsData.data_source !== 'FORM_BUILDERS' &&
              addStatsData.data_source !== 'APPROVALS' &&
              addStatsData.data_source !== 'INTEGRATIONS' &&
              addStatsData.display_type !== 'TIME_STAMP'
            "
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="(filter, index) of statEntityFilters.filter(
                (e) => !e.parent_filter_id
              )"
              :key="'filter_' + index"
              :value="filter._id"
              :label="filter.filter_name"
            >
              <span style="float: left">{{ filter.filter_name }}</span>
            </el-option>
          </el-select>
          <div
            v-if="
              addStatsData.type == 'TABLE' ||
              addStatsData.type == 'CHART' ||
              (addStatsData.type == 'STAT' &&
                addStatsData.data_source !== 'FORM_BUILDERS' &&
                addStatsData.data_source !== 'INTEGRATIONS' &&
                allDashboardstats &&
                allDashboardstats.includeGlobalDateFilter)
            "
          >
            Apply date filter on this field:
            <el-select
              placeholder="Select date field"
              v-model="addStatsData.date_filter_field"
              default-first-option
              style="width: 100%"
              clearable
            >
              <template v-if="addStatsData.data_source !== 'APPROVALS'">
                <el-option
                  v-for="(field, index) of getAllDateFields"
                  :value="field.key"
                  :key="field.key + '_stat_' + index"
                  :label="`${field.template_name} - ${field.label} `"
                >
                  <span>{{ field.template_name }} - {{ field.label }}</span>
                </el-option>
              </template>
              <el-option value="created_at" label="Created Date"
                >Created Date</el-option
              >
              <el-option value="updated_at" label="Updated Date"
                >Updated Date</el-option
              >
              <el-option
                value="approved_at"
                label="Approved Date"
                v-if="
                  addStatsData.data_source == 'APPROVALS' &&
                  addStatsData.formbuilder_approval_filter == 'APPROVED'
                "
              >
                Approved Date
              </el-option>
              <el-option
                value="rejected_at"
                label="Rejected Date"
                v-if="
                  addStatsData.data_source == 'APPROVALS' &&
                  addStatsData.formbuilder_approval_filter == 'REJECTED'
                "
              >
                Rejected Date
              </el-option>
            </el-select>
            <el-select
              v-if="
                addStatsData.date_filter_field && addStatsData.type == 'TABLE'
              "
              placeholder="Pick default"
              v-model="addStatsData.default_date_filter"
              :size="'mini'"
              clearable
            >
              <el-option
                v-for="(el, index) in pickerOptions"
                :key="el.value + '_' + index"
                :value="el.value"
                :label="el.label"
                >{{ el.label }}
              </el-option>
            </el-select>
            <el-checkbox
              style="margin-left: 8px"
              v-model="addStatsData.ignore_year"
              v-if="addStatsData.date_filter_field"
              class="mt-1"
              >Show every year</el-checkbox
            >
          </div>
          <div
            v-if="
              (isEntityDashboard && addStatsData.type == 'TABLE') ||
              addStatsData.type == 'CHART' ||
              (addStatsData.type == 'STAT' &&
                addStatsData.data_source !== 'FORM_BUILDERS' &&
                addStatsData.data_source !== 'APPROVALS' &&
                addStatsData.data_source !== 'INTEGRATIONS' &&
                allDashboardstats &&
                selectedEntityRelationalData)
            "
          >
            <span>Show data based on :</span>
            <el-select
              v-model="addStatsData.selectedRelationalFilter"
              placeholder="Self related Filter"
            >
              <el-option value="login_user" label="Login User"></el-option>
              <el-option
                v-for="item in getEntityFieldsCurrentEntity"
                :key="item.entity_id"
                :label="item.label"
                :value="item.entity_id + '#' + item.template_key"
              ></el-option>
            </el-select>
          </div>
          <label
            v-if="
              (addStatsData.display_type == 'sum' ||
                addStatsData.display_type == 'avg' ||
                addStatsData.display_type == 'count_and_sum') &&
              addStatsData.type == 'STAT'
            "
            class="mt-1"
            >{{
              addStatsData.display_type == "sum"
                ? "Sum of"
                : addStatsData.display_type == "count_and_sum"
                ? "Count and sum of"
                : "Average of"
            }}</label
          >
          <el-select
            v-if="
              (addStatsData.display_type == 'sum' ||
                addStatsData.display_type == 'avg' ||
                addStatsData.display_type == 'count_and_sum') &&
              addStatsData.type == 'STAT'
            "
            v-model="addStatsData.sum_field"
            placeholder="Select field"
            clearable
            @change="getFieldType"
            style="width: 100%"
          >
            <el-option
              v-for="(field, index) of getTemplateFields"
              :value="field.key"
              :key="field.key + '_stat_' + index"
              :label="`${field.template_name} - ${field.label} `"
            >
              <span>{{ field.template_name }} - {{ field.label }}</span>
            </el-option> </el-select
          ><br />
          <el-checkbox
            v-model="addStatsData.compare"
            v-if="
              addStatsData.type == 'STAT' &&
              addStatsData.data_source !== 'FORM_BUILDERS' &&
              addStatsData.data_source !== 'APPROVALS' &&
              addStatsData.data_source !== 'INTEGRATIONS' &&
              addStatsData.display_type !== 'TIME_STAMP'
            "
            >Compare</el-checkbox
          ><br />
          <div v-if="addStatsData.compare">
            <label>Sort by</label><br />
            <el-select v-model="addStatsData.sort_by">
              <el-option
                v-for="(field, index) in getAllFields"
                :key="index"
                :value="field.key"
                :label="`${field.template_name} - ${field.label} `"
              >
              </el-option> </el-select
            ><br /><br />
            <label>Sort Order</label><br />
            <el-radio-group v-model="addStatsData.sort_order">
              <el-radio label="asc">Ascending</el-radio>
              <el-radio label="des">Descending</el-radio> </el-radio-group
            ><br /><br />
            <label>Compare with previous</label><br />
            <el-radio-group v-model="addStatsData.compare_with">
              <el-radio label="one">One</el-radio>
              <el-radio label="all">Cumulative</el-radio>
            </el-radio-group>
          </div>
          <div
            v-if="
              addStatsData.data_source !== 'FORM_BUILDERS' &&
              addStatsData.data_source !== 'APPROVALS' &&
              addStatsData.data_source !== 'INTEGRATIONS' &&
              addStatsData.type == 'TABLE'
            "
          >
            Permissions :
            <el-checkbox
              style="margin-left: 8px"
              v-model="addStatsData.send_notification"
              class="mt-1"
              >Send Notification
            </el-checkbox>
          </div>
          <div v-if="addStatsData.display_type == 'TIME_STAMP'">
            <div class="d-flex">
              <label class="mr-2">Timestamp type: </label>
              <el-select v-model="addStatsData.timestamp_type">
                <el-option label="Created at" value="created_at"></el-option>
                <el-option label="Updated at" value="updated_at"></el-option>
              </el-select>
            </div>
            <div class="d-flex">
              <label class="mr-2">Timestamp Order: </label>
              <el-select v-model="addStatsData.timestamp_record">
                <el-option
                  label="Latest Created"
                  value="latest_created"
                ></el-option>
                <el-option
                  label="Latest Updated"
                  value="latest_updated"
                ></el-option>
                <el-option
                  label="Oldest Created"
                  value="oldest_created"
                ></el-option>
                <el-option
                  label="Oldest Updated"
                  value="oldest_updated"
                ></el-option>
              </el-select>
            </div>
            <div class="d-flex">
              <label class="mr-2">Timestamp Format: </label>
              <el-select v-model="addStatsData.timestamp_format">
                <el-option-group
                  v-for="group in timeStampFormats"
                  :key="group.label"
                  :label="group.label"
                >
                  <el-option
                    v-for="format in group.formats"
                    :key="format"
                    :value="format"
                    :label="$moment().format(format)"
                  ></el-option>
                </el-option-group>
              </el-select>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- <el-form :model="addStatsData" label-width="100px">
      <el-form-item label="Chart type" v-if="addStatsData.type == 'CHART'">
      </el-form-item>
      <el-form-item label="Filters" v-else> </el-form-item>
    </el-form>-->
    <dialog-component
      :title="'Select Stat Icon'"
      :visible="iconPickerdialogVisible"
      @before-close="iconPickerdialogVisible = false"
      top="25px"
      :containerMaxWidth="'77%'"
      :isShowFooter="false"
    >
      <!-- <div v-if="isApplicationUser" class="iconslistScrollable">
        <div>
          <el-input placeholder="Search by name" v-model="searchIcon" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <el-row>
          <el-tabs v-model="selectedCategory">
            <el-tab-pane
              :label="category.name"
              :name="category.key"
              v-for="(category, i) in menuIconsForApp"
              :key="category.key + '_' + i"
            ></el-tab-pane>
          </el-tabs>
        </el-row>

        <el-row :gutter="55" style="margin-top: 15px">
          <el-col :xs="4" :sm="3" :md="2" :lg="2" :xl="1" v-for="(icon, index) in getSelectedCategory" :key="index">
            <div class="circle-icon" :style="`background: var(--primary-color) !important;cursor: pointer`"
              @click="setIcon(icon)">
              if we're using el-tooltip it's applying padding:15px from external css that's why it's not
            displaying the icon image in proper alignment.Hence I have used title attribute for img tag.
              <img :src="require('@/assets/img/icons/' +
                getParentPath(selectedCategory) +
                '/' +
                icon.url)
                " width="27" height="25" style="
                  margin-top: 10px !important;
                  margin-right: 2px !important;
                " :title="icon.name" />
              <el-tooltip
                effect="dark"
                :content="icon.name"
                placement="top-start"
                style="padding: 0;"
              >
                <img
                  :src="
                    require('@/assets/img/icons/' +
                      getParentPath(selectedCategory) +
                      '/' +
                      icon.url)
                  "
                  width="27"
                  height="25"
                  style="margin-top: 10px !important; margin-right: 2px !important;"
                />
              </el-tooltip>
            </div>
          </el-col>
        </el-row>
      </div> -->
      <div class="iconslistScrollable">
        <icons-list @icon-data="setIconPath"></icons-list>
        <!-- <el-row :gutter="0">
          <el-col
            :xs="4"
            :sm="3"
            :md="2"
            :lg="2"
            :xl="1"
            v-for="(icon, index) in menuIcons"
            :key="index"
            class="border-radius"
            style="cursor: pointer"
          >
            <div
              class="grid-content ep-bg-purple"
              v-on:click="setIconPath(icon)"
              style="cursor: pointer"
            >
              <el-tooltip
                effect="dark"
                :content="icon.name"
                placement="top-start"
              >
                <img
                  :src="require('@/assets/img/icons/menu/' + icon.url)"
                  :alt="icon.name"
                  width="25"
                />
              </el-tooltip>
            </div>
          </el-col>
        </el-row> -->
      </div>
    </dialog-component>

    <dialog-component
      title="Add table columns"
      :visible.sync="openTableColumsModal"
      :containerMaxWidth="'80%'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      draggable
      @before-close="resetModal"
    >
      <el-row>
        <el-link
          icon="el-icon-circle-plus"
          type="primary"
          @click="addNewColumn"
          style="float: right"
          :underline="false"
          >Add</el-link
        >
      </el-row>
      <el-row>
        <el-scrollbar wrap-style="max-height: 250px; width: 100% !important;">
          <el-table :data="tableFieldGroupByFieldsModal" border>
            <el-table-column prop="Column" label="Column" width="180">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.key"
                  placeholder="Table columns"
                  clearable
                  @change="fillLabel(scope.row.key, scope.$index)"
                >
                  <el-option
                    label="Count"
                    value="count"
                    :disabled="
                      tableFieldGroupByFieldsModal.find((e) => e.key == 'count')
                        ? true
                        : false
                    "
                  >
                  </el-option>
                  <el-option
                    v-for="(field, index) of getTotalFields"
                    :value="field.key"
                    :key="field.key + index"
                    :label="`${field.template_name} - ${field.label} `"
                    :disabled="
                      tableFieldGroupByFieldsModal.find(
                        (e) => e.key == field.key
                      )
                        ? true
                        : false
                    "
                  >
                    <span>{{ field.template_name }} - {{ field.label }}</span>
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="Contact Type"
              label="Column name"
              width="180"
            >
              <template slot-scope="scope">
                <el-input placeholder="Enter name" v-model="scope.row.name">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Actions" label="Actions" width="180">
              <template slot-scope="scope">
                <el-link
                  @click.native.prevent="
                    deleteRow(scope.$index, tableFieldGroupByFieldsModal)
                  "
                  type="danger"
                  icon="el-icon-delete"
                  :underline="false"
                ></el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openTableColumsModal = false">Cancel</el-button>
        <el-button
          type="primary"
          @click="saveTableGroupBy"
          :disabled="checkTableGroupByField"
          >Save</el-button
        >
      </span>
    </dialog-component>

    <dialog-component
      :title="'Color Rules'"
      :visible="colorRulesDialogVisible"
      @before-close="colorRulesDialogVisible = false"
      :containerWidth="'800px'"
    >
      <template-form-rules-widget
        :allFields="colorRulesFields"
        :templateRules="addStatsData.rules"
        :fromScheduling="true"
        @form-rule-added="updateFormRules"
        @form-rule-delete="deleteFormRules"
        class="popUp-content"
      >
      </template-form-rules-widget>
    </dialog-component>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import CustomDashboardConfig from "@/mixins/CustomDashboardHelper.js";
import templateBuilderHelper from "../../mixins/templateBuilderHelper";
var menuIconsData = require("@/assets/data/menu_icons.json");
var menuIconsDataApp = require("@/assets/data/menu_icons_application.json");
import { fetchAllEntityFiltersByEntity } from "@/repo/filtersRepo";
import { fetchEntitiesByPagination, fetchEntityById } from "@/repo/entityRepo";
import { postAPICall } from "@/helpers/httpHelper";
import { fetchEntityViews } from "@/repo/entityViewsRepo";
import EntitiesHelper from "../../mixins/EntitiesHelper";
import { fetchAllEntityCustomizationsByEntity } from "@/repo/entityCustomizationRepo";
// import {IntegrationConfiguration} from "./integrationConfiguration.vue";

export default {
  mixins: [CustomDashboardConfig, templateBuilderHelper, EntitiesHelper],
  props: {
    addStatsData: Object,
    allDashboardstats: Object,
    getRelationshipEntities: Array,
    getNestedRelationshipEntities: Array,
    isFromApplicationuser: Boolean,
    selectedEntity: Object,
    globalVariablesData: Array,
    // getAllEntities: Object,
    getAllCompanyTemplatesData: Object,
    permittedEntities: Array,
    permittedRelatedEntities: Array,
    permittedNestedRelatedEntities: Array,
    integrations: Array,
  },
  components: {
    IntegrationConfiguration: () => import("./integrationConfiguration.vue"),
    TemplateFormRulesWidget: () =>
      import("@/components/widgets/TemplateFormRulesWidget.vue"),
  },
  async mounted() {
    if (this.$route.name == "entity-custom-dashboard-config") {
      this.isEntityDashboard = true;
    }
    this.modalLoading = true;
    let [entities, entityViews] = await Promise.all([
      fetchEntitiesByPagination({
        get_all: true,
      }),
      fetchEntityViews({ get_all: true }),
    ]);
    if (this.isEntityDashboard && this.$route.params.entityId) {
      this.currentEntityFields = await this.fetchEntityDetails(
        this.$route.params.entityId,
        true,
        false,
        false,
        false,
        true,
        true
      );
      if (!this.addStatsData.selectedRelationalFilter) {
        this.addStatsData.selectedRelationalFilter = "login_user";
      }
    }
    this.allFormbuilders = await this.fetchAllFormbuilders();
    this.modalLoading = false;
    if (entities?.data) {
      this.getAllEntities = { ...entities };
    }
    if (entityViews?.data) {
      this.getAllEntityViews = { ...entityViews };
    }
    if (this.addStatsData?.type == "STAT") {
      // this.setSelectedEvents();
    } else if (this.addStatsData?.type == "SCHEDULING") {
      this.setSchedulingData();
    }
    await this.fetchTemplateFields();
    if (this.addStatsData.entity_id) {
      if (this.addStatsData.is_relational_data) {
        this.selectedEntityRelationalData = this.addStatsData.entity_id;
      }
      if (this.addStatsData.is_nested_relational_data) {
        this.selectedEntityNestedRelationalData =
          this.addStatsData.selectedEntityNestedRelationalData;
      }
      this.fetchAllEntityFilters();
      if (this.addStatsData.display_type == "MISSING_SLOTS") {
        this.fetchRelatedEntities(this.addStatsData.entity_id);
      }
    }
    if (
      this.addStatsData.type == "STAT" &&
      (this.addStatsData.display_type == "sum" ||
        this.addStatsData.display_type == "avg" ||
        this.addStatsData.display_type == "MISSING_SLOTS")
    ) {
      await this.fetchTemplateFields(true, true);
    }
    if (this.getCompanyDetails) {
      this.iconBgColor = this.getCompanyDetails.button.background;
      this.iconColor = this.getCompanyDetails.icon_color;
    }

    //fetch entity group by fields
    if (this.addStatsData.type == "CHART") {
      if (
        this.addStatsData?.pie_chart_field_options &&
        !this.addStatsData?.pie_chart_field_options_colors
      ) {
        this.addStatsData.pie_chart_field_options_colors = [];
        this.optionsChanged(this.addStatsData?.pie_chart_field_options);
      }
      this.fetchFieldOptions(this.addStatsData?.pie_chart_field);
      if (this.addStatsData?.pie_chart_field_group_by) {
        await this.getSelectedFieldOptions(
          this.addStatsData.pie_chart_field_group_by
        );
      }
    }
    if (
      this.addStatsData.type == "TABLE" &&
      this.addStatsData.table_field_group_by &&
      this.addStatsData.table_field_sub_group_by
    ) {
      await this.getSelectedFieldOptions(
        this.addStatsData.table_field_sub_group_by
      );
    }
    if (this.addStatsData?.combinedData?.[0]?.sum_field == null) {
      this.rows = [{ sum_field: null, chart_type: null }];
    } else {
      this.rows = this.addStatsData.combinedData;
    }
    if (this.addStatsData?.isCustomization == true) {
      this.loadCustomizations(this.addStatsData.entity_id);
    }
    this.approvalHoldName = this.getCompanyDetails
      ?.formbuilder_approval_hold_name
      ? this.getCompanyDetails.formbuilder_approval_hold_name
      : "HOLD";
  },
  data() {
    return {
      schedulerEntityFilters: [],
      selectedColumns: [],
      statEntityFilters: [],
      modalLoading: false,
      currentEntityFields: [],
      iconPickerdialogVisible: false,
      menuIcons: menuIconsData,
      menuIconsForApp: menuIconsDataApp.categories,
      iconBgColor: "",
      iconColor: "White",
      getAllEntities: [],
      getTemplateFields: [],
      getAllDateFields: [],
      resourceEntityFields: [],
      schedulingEntityFields: [],
      jobEntityFields: [],
      schedulerEntitySubGroupsData: [],
      entityFiltersMapping: {},
      getAllFields: [],
      pickerOptions: [
        {
          label: "Today",
          value: "today",
        },
        {
          label: "Yesterday",
          value: "yesterday",
        },
        {
          label: "Last week",
          value: "last_week",
        },
        {
          label: "This week",
          value: "this_week",
        },
        {
          label: "Next week",
          value: "next_week",
        },
        {
          label: "Last month",
          value: "last_month",
        },
        {
          label: "This month",
          value: "this_month",
        },
        {
          label: "Next month",
          value: "next_month",
        },
        {
          label: "Last quarter",
          value: "last_quarter",
        },
        {
          label: "This quarter",
          value: "this_quarter",
        },
        {
          label: "Next quarter",
          value: "next_quarter",
        },
        {
          label: "Last year",
          value: "last_year",
        },
        {
          label: "This year",
          value: "this_year",
        },
        {
          label: "Next year",
          value: "next_year",
        },
      ],
      componentTypes: [
        {
          label: "Table",
          value: "TABLE",
        },
        {
          label: "Chart",
          value: "CHART",
        },
      ],
      chartTypes: [
        {
          label: "Pie",
          value: "PIE",
        },
        {
          label: "Bar",
          value: "BAR",
        },
        {
          label: "Doughnut",
          value: "DOUGHNUT",
        },
        {
          label: "Line",
          value: "LINE",
        },
      ],
      searchIcon: "",
      selectedCategory: "default",
      getTotalFields: [],
      selectedEntityRelationalData: "",
      selectedEntityNestedRelationalData: "",
      pieChartFieldGroupByOptions: [],
      pieChartFieldEntityValues: [],
      pieChartFieldEntity: null,
      pieChartFieldSelectOptions: [],
      groupByFieldEntityValues: [],
      groupByFieldEntity: null,
      chartFilters: [],
      tableFieldGroupByFieldsModal: [],
      openTableColumsModal: false,
      activeClassIndex: -1,
      showSelectOperator: "",
      showSelectField: "",
      manualNumber: "",
      activeClassName: "active",
      refreshFormula: false,
      rows: this.addStatsData.combinedData,
      subChartTypes: [
        {
          label: "Line",
          value: "line",
        },
        {
          label: "Bar",
          value: "bar",
        },
      ],
      isEntityDashboard: false,
      selectedApplicationEvents: [],
      allFormbuilders: [],
      formbuilderFilters: [
        {
          value: "ALL",
          label: "ALL",
        },
        {
          value: "APPROVAL_PENDING",
          label: "Approval status - PENDING",
        },
        {
          value: "APPROVAL_APPROVED",
          label: "Approval status - APPROVED",
        },
        {
          value: "APPROVAL_REJECTED",
          label: "Approval status - REJECTED",
        },
        {
          value: "FORM_PENDING",
          label: "Form completion status - PENDING",
        },
        {
          value: "FORM_COMPLETED",
          label: "Form completion status - COMPLETED",
        },
      ],
      approvalHoldName: "HOLD",
      getEntityFieldRelatedEntities: [],
      otherEntityFields: [],
      otherEntitiesLoading: false,
      getAllEntityViews: null,
      timeStampFormats: [
        {
          label: "Date",
          formats: [
            "YYYY-MM-DD", // 2025-02-18
            "DD-MM-YYYY", // 18-02-2025
            "MM/DD/YYYY", // 02/18/2025
            "YYYY/MM/DD", // 2025/02/18
            "ddd, MMM Do YYYY", // Tuesday, February 18th 2025
            "D MMM YYYY", // 18 Feb 2025
          ],
        },
        {
          label: "Time",
          formats: [
            "HH:mm:ss", // 14:30:45 (24-hour format)
            "hh:mm:ss A", // 02:30:45 PM (12-hour format)
            "HH:mm", // 14:30
            "hh:mm A", // 02:30 PM
            "h:mm:ss a", // 2:30:45 pm
            "LT", // 2:30 PM
            "LTS", // 2:30:45 PM
          ],
        },
        {
          label: "Date & Time",
          formats: [
            "YYYY-MM-DD HH:mm:ss", // 2025-02-18 14:30:45
            "MM/DD/YYYY hh:mm A", // 02/18/2025 02:30 PM
            "ddd, MMM D, YYYY h:mm A", // Tue, Feb 18, 2025 2:30 PM
            "YYYY/MM/DD hh:mm:ss A", // 2025/02/18 02:30:45 PM
          ],
        },
      ],
      colorRulesDialogVisible: false,
      colorRulesFields: [],
      chartscustomizationOptions: [],
    };
  },
  computed: {
    ...mapGetters("entities", [
      "getEntityCreatedStatus",
      "getEntityCreatedData",
      "getCustomDashboardStats",
      "getEntityDataById",
      "getEntityDataUpdateStatus",
      "getEntityErrors",
      // "getAllEntities",
    ]),
    ...mapGetters("filters", ["getSingleFilterData", "getAllEntityFilters"]),
    ...mapGetters("entityCustomization", ["getAllCustomizations"]),
    // ...mapGetters("companyTemplates", ["getAllCompanyTemplatesData"]),
    ...mapGetters("company", [
      "getCompanyDetails",
      "getUpdateCompany",
      "getCompanyLogo",
      "getContactLoginSlug",
    ]),
    // ...mapGetters("entityViews", ["getAllEntityViews"]),
    getAllEntitiesData() {
      if (this.getAllEntities && this.getAllEntities?.data) {
        if (this.isEntityDashboard) {
          return (this.getAllEntities.data || []).filter(
            (e) => this.permittedEntities.indexOf(e._id) != -1
          );
        }
        return this.getAllEntities.data;
      }
      return [];
    },
    getEntityFieldsCurrentEntity() {
      if (!this.currentEntityFields?.length) return [];
      return (
        (this.currentEntityFields || []).filter(
          (e) => e.input_type == "ENTITY"
        ) || []
      );
    },
    isApplicationUser() {
      return (
        this.$route.name == "entity-custom-dashboard-config" ||
        this.$route.name == "application-user-dashboard"
      );
    },
    tableData() {
      return [
        {
          label: "Entity",
          entityId: this.addStatsData.entity_id,
          entityName: this.getEntityName(
            this.addStatsData.entity_id,
            this.getAllEntitiesData
          ),
          selectedCustomization:
            this.addStatsData.selectedCustomizations?.entity || null,
          customizations: [],
        },
        {
          label: "Relational Entity",
          entityId: this.selectedEntityRelationalData,
          entityName: this.getEntityName(
            this.selectedEntityRelationalData,
            this.getRelationshipEntities
          ),
          selectedCustomization:
            this.addStatsData.selectedCustomizations?.relationalEntity || null,
          customizations: [],
        },
        {
          label: "Nested Relational Entity",
          entityId: this.selectedEntityNestedRelationalData,
          entityName: this.getEntityName(
            this.selectedEntityNestedRelationalData,
            this.getNestedRelationshipEntities
          ),
          selectedCustomization:
            this.addStatsData.selectedCustomizations?.nestedRelationalEntity ||
            null,
          customizations: [],
        },
      ].filter((row) => {
        if (!row.entityId) return false;
        if (
          row.label === "Entity" &&
          row.entityId === this.selectedEntityRelationalData
        ) {
          return false;
        }
        return true;
      });
    },
    customizationOptions() {
      if (!this.getAllCustomizations?.data) return [];
      const entityIdList = this.tableData
        .map((row) => row.entityId)
        .filter((id) => id);
      const filteredCustomizations = this.getAllCustomizations?.data.filter(
        (custom) => entityIdList.includes(custom.entity_id)
      );

      return filteredCustomizations.map((custom) => ({
        label: custom.label,
        value: custom._id,
      }));
    },
    // sanitizedEvent: {
    //   get() {
    //     return this.addStatsData.event === false
    //       ? null
    //       : this.addStatsData.event;
    //   },
    //   set(value) {
    //     this.addStatsData.event = value;
    //   },
    // },
    getSelectedCategory() {
      let selectedIcons = this.menuIconsForApp.find(
        (e) => e.key == this.selectedCategory
      );
      if (selectedIcons?.icons) {
        if (this.searchIcon) {
          return selectedIcons.icons.filter((e) =>
            e.name.toLowerCase().includes(this.searchIcon.toLowerCase())
          );
        }
        return selectedIcons.icons;
      }
      return [];
    },
    checkTableGroupByField() {
      if (
        this.addStatsData?.table_field_group_by_fields &&
        this.addStatsData.table_field_group_by_fields.length
      ) {
        let empty = this.addStatsData.table_field_group_by_fields.find(
          (e) => !e || !e.name || !e.key
        );
        return empty ? true : false;
      }
      return (
        !this.addStatsData?.table_field_group_by_fields ||
        !this.addStatsData?.table_field_group_by_fields.length
      );
    },
    getFields() {
      if (this.allDashboardstats?.allStatComponents) {
        return this.allDashboardstats.allStatComponents.filter(
          (e) => e.display_type != "FORMULA"
        );
      }
      return [];
    },
    // getPredefinedApplications() {
    //   return (this.integrations || []).filter(
    //     (e) => e.app_type == "PRE_DEFINED"
    //   );
    // },
    // selectedIntegration() {
    //   return this.getPredefinedApplications.find(
    //     (e) => e._id == this.addStatsData.integrationsSettings.integration_id
    //   );
    // },
    // selectedApplication() {
    //   return this.predefinedIntegrations.find(
    //     (e) =>
    //       this.addStatsData?.integrationsSettings.integration_id &&
    //       e.key == this.selectedIntegration?.application
    //   );
    // },
    // selectedApplicationDependencies() {
    //   let dependencies = [];
    //   // if (this.selectedApplication?.settings?.requiredFields) {
    //   //   dependencies = [...this.selectedApplication.settings.requiredFields];
    //   // }
    //   if (this.selectedEvent?.settings?.requiredFields) {
    //     dependencies = [
    //       ...dependencies,
    //       ...this.selectedEvent.settings.requiredFields,
    //     ];
    //   }
    //   return dependencies;
    // },
    // selectedEvent() {
    //   return this.selectedApplicationEvents.find(
    //     (e) => e.eventKey == this.addStatsData?.event
    //   );
    // },
    isAllOptionSelected() {
      return this.addStatsData?.selected_formbuilder_ids?.includes("ALL");
    },
  },
  methods: {
    optionsChanged(options) {
      while (
        this.addStatsData.pie_chart_field_options_colors.length < options.length
      ) {
        this.addStatsData.pie_chart_field_options_colors.push("#FFFFFF");
      }
      this.addStatsData.pie_chart_field_options_colors =
        this.addStatsData.pie_chart_field_options_colors.slice(
          0,
          options.length
        );
    },
    getOptionLabel(option) {
      return this.getLabel(
        this.pieChartFieldEntityValues.find((dt) => dt._id == option),
        this.pieChartFieldEntityValues.findIndex((dt) => dt._id == option),
        this.pieChartFieldEntity
      );
    },
    onCustomizationChange(val) {
      if (val) {
        this.loadCustomizations(this.addStatsData.entity_id);
      } else {
        this.addStatsData.selectedCustomization = "";
      }
    },
    async loadCustomizations(entity_id) {
      this.chartscustomizationOptions =
        await fetchAllEntityCustomizationsByEntity(entity_id);
    },
    async getEntityCustomizations(entity_id) {
      if (!entity_id) return [];

      this.loading = true;
      await this.$store.dispatch(
        "entityCustomization/fetchAllEntityCustomizations",
        entity_id
      );

      this.loading = false;
      return this.getAllCustomizations;
    },
    handleCustomizationChange(row, value) {
      if (!this.addStatsData.selectedCustomizations) {
        this.$set(this.addStatsData, "selectedCustomizations", {});
      }
      if (row.label === "Entity") {
        this.$set(this.addStatsData.selectedCustomizations, "entity", value);
      } else if (row.label === "Relational Entity") {
        this.$set(
          this.addStatsData.selectedCustomizations,
          "relationalEntity",
          value
        );
      } else if (row.label === "Nested Relational Entity") {
        this.$set(
          this.addStatsData.selectedCustomizations,
          "nestedRelationalEntity",
          value
        );
      }

      row.selectedCustomization = value;
    },
    getEntityName(id, list) {
      const entity = list.find((e) => e._id === id || e.key === id);
      return entity ? entity.name : id;
    },
    async openColorRulesDialog() {
      let fields = await this.fetchEntityDetails(
        this.addStatsData.scheduler_entity,
        true,
        false,
        false,
        false,
        false,
        true
      );
      this.colorRulesFields = fields.map((fd) => {
        fd.key = fd.template_key;
        return fd;
      });
      this.colorRulesDialogVisible = true;
    },
    updateFormRules(data) {
      if (data.index == -1) {
        this.addStatsData.rules.push(data);
      } else {
        this.addStatsData.rules[data.index] = { ...data };
      }
    },
    deleteFormRules(index) {
      this.addStatsData.rules.splice(index.index, 1);
    },
    // async setAsset() {
    //   if (this.sanitizedEvent) {
    //     let selectedIntegration = this.selectedIntegrationConnection(
    //       this.addStatsData.integrationsSettings.integration_id
    //     );
    //     let matchedApplication = this.matchedIntegrationApplication(
    //       selectedIntegration.application
    //     );
    //     let events = matchedApplication.events;
    //     let matchedEvent = events.find(
    //       (event) => event._id === this.sanitizedEvent
    //     );
    //     this.addStatsData.integrationsSettings.event = matchedEvent;
    //     this.addStatsData.apply_date_filter = matchedEvent?.settings
    //       ?.isDateFilterIncluded
    //       ? true
    //       : false;
    //     this.loadRequiredData(
    //       matchedEvent,
    //       matchedApplication,
    //       selectedIntegration.connection_id
    //     );
    //   }
    //   // if (this.addStatsData?.event) {
    //   //   let selectedEvent = this.selectedApplicationEvents.find(
    //   //     (fl) => fl.eventKey == this.addStatsData.event
    //   //   );
    //   //   if (selectedEvent?.asset) {
    //   //     this.addStatsData["asset"] = selectedEvent.asset;
    //   //   }
    //   // } else {
    //   //   this.addStatsData["asset"] = "";
    //   // }
    // },
    getOtherEntityFields() {
      this.otherEntityFields = [];
      if (this.addStatsData.other_entity_id) {
        let entity_id = this.addStatsData.other_entity_id.split("#")[0];

        let entity = this.getAllEntitiesData.find((e) => e._id == entity_id);
        if (!entity) {
          entity = (this.getAllEntities?.data || []).find(
            (e) => e._id == entity_id
          );
        }
        if (entity?.templates) {
          const templateIds = (entity?.templates || [])
            .filter((e) => !e.is_repeatable)
            .flatMap((e) => e.template_id);

          let entityTemplates = (
            this.getAllCompanyTemplatesData &&
            this.getAllCompanyTemplatesData.data
              ? this.getAllCompanyTemplatesData.data
              : []
          ).filter((e) => templateIds.indexOf(e._id) !== -1);

          entityTemplates.forEach((e) => {
            let data = JSON.parse(JSON.stringify(e));
            this.otherEntityFields = [
              ...this.otherEntityFields,
              ...this.getTemplateFieldsByType(data, []),
            ];
          });
        }
      }
    },
    // setSelectedEvents() {
    //   if (this.addStatsData?.integrationsSettings.integration_id) {
    //     let selectedIntegration = this.selectedIntegrationConnection(
    //       this.addStatsData.integrationsSettings.integration_id
    //     );
    //     if (selectedIntegration?.application) {
    //       let matchedApplication = this.matchedIntegrationApplication(
    //         selectedIntegration.application
    //       );
    //       if (matchedApplication?.events) {
    //         this.selectedApplicationEvents = matchedApplication.events;
    //       } else {
    //         this.selectedApplicationEvents = [];
    //       }
    //     }
    //   }
    // },
    setSchedulingData() {
      this.getEntityFields(this.addStatsData.scheduler_entity, "SCHEDULER");
      this.fetchSchedulerEntityFilters(this.addStatsData.scheduler_entity);
      if (this.addStatsData.resource_entity) {
        this.getEntityFields(
          this.schedulingEntityFields.find(
            (e) => e.template_key == this.addStatsData.resource_entity
          ).entity_id,
          "RESOURCE"
        );
      }
      if (this.addStatsData.job_entity) {
        this.getEntityFields(
          this.schedulingEntityFields.find(
            (e) => e.template_key == this.addStatsData.job_entity
          ).entity_id,
          "JOB"
        );
      }
      if (this.addStatsData.scheduler_entity_sub_groups) {
        this.fetchSubGroupFilters();
      }
    },
    getEntityFields(entity_id, type) {
      let selectedEntity = this.getAllEntitiesData.find(
        (e) => e._id == entity_id
      );
      let fields = [];
      (selectedEntity || []).templates.forEach((t) => {
        let temp = (this.getAllCompanyTemplatesData?.data || []).find(
          (e) => e._id == t.template_id
        );
        fields = [
          ...fields,
          ...(temp.sections?.[0]?.fields || []).map((f) => {
            f.template_key = temp._id + "#" + f.key;
            return f;
          }),
        ];
      });
      if (type == "RESOURCE") {
        this.resourceEntityFields = [...fields];
      } else if (type == "JOB") {
        this.jobEntityFields = [...fields];
      } else {
        this.schedulingEntityFields = [...fields];
      }
    },
    async fetchSchedulerEntityFilters(entityId) {
      if (!entityId) return;

      this.schedulerEntityFilters = [];
      this.selectedSchedulerFilter = "";
      // this.loading = true;

      try {
        const filters = await fetchAllEntityFiltersByEntity({ entityId });
        this.schedulerEntityFilters = filters || [];
      } catch (e) {
        console.error("Failed to fetch scheduler entity filters", e);
        this.schedulerEntityFilters = [];
      }

      // this.loading = false;
    },
    async fetchSubGroupFilters() {
      this.schedulerEntitySubGroupsData = [];
      await Promise.all(
        this.addStatsData.scheduler_entity_sub_groups.map(async (fl) => {
          let field = this.schedulingEntityFields.find(
            (e) => e.template_key == fl
          );
          if (field?.entity_id) {
            let filters =
              this.entityFiltersMapping[field.entity_id] ||
              (await fetchAllEntityFiltersByEntity({
                entityId: field.entity_id,
              }));
            this.entityFiltersMapping[field.entity_id] = filters;
            this.schedulerEntitySubGroupsData.push({
              label: field.label,
              entity_id: field.entity_id,
              filters: filters,
              key: fl,
            });
          }
        })
      );
    },
    autoFillComponentName() {
      this.addStatsData.component_name = (
        this.getAllEntityViews?.data || []
      ).find((e) => e._id == this.addStatsData.entity_view_id)?.name;
    },
    async fetchFieldOptionsForChart(field) {
      this.addStatsData.pie_chart_field_options = [];
      await this.fetchFieldOptions(field);
    },
    popField() {
      if (this.addStatsData?.selected_fields) {
        this.addStatsData.selected_fields.pop();
      }
    },
    refreshFormulaData() {
      this.refreshFormula = true;
      setTimeout(() => {
        this.refreshFormula = false;
      });
    },
    onSelectParentheses(parentheses) {
      if (this.addStatsData?.selected_fields) {
        this.addStatsData.selected_fields.push({
          type: "PARENTHESES",
          parentheses,
        });
      } else {
        this.addStatsData["selected_fields"] = [
          { type: "PARENTHESES", parentheses },
        ];
      }
      this.showSelectParentheses = "";
      this.refreshFormulaData();
    },
    onSelectField(key) {
      let selectedField = this.getFields.find((e) => e.keyValue == key);
      if (!selectedField) {
        return;
      }
      let item = {
        key: selectedField.keyValue,
        field_name: selectedField.component_name,
        type: "FIELD",
      };
      if (item.formula) {
        item["type"] = "FORMULA";
      } else {
        item["type"] = "FIELD";
      }
      if (selectedField.is_currency && selectedField.currency_type) {
        this.addStatsData.is_currency = true;
        this.addStatsData["currency_type"] = selectedField.currency_type;
      }
      if (this.activeClassIndex > -1) {
        let fieldData =
          this.addStatsData.selected_fields[this.activeClassIndex];
        if (this.addStatsData?.selected_fields) {
          this.addStatsData.selected_fields.push(item);
        } else {
          this.addStatsData["selected_fields"] = [item];
        }
        this.showSelectField = "";
        if (
          fieldData &&
          (fieldData.type == "FIELD" ||
            fieldData.type == "FORMULA" ||
            fieldData.type == "NUMBER" ||
            fieldData.type == "DATE" ||
            fieldData.type == "TIME" ||
            fieldData.type == "DATE_TIME_RANGE" ||
            fieldData.type == "DATE_RANGE" ||
            fieldData.type == "LIST" ||
            fieldData.type == "GLOBAL_VARIABLE")
        ) {
          this.addStatsData.selected_fields[this.activeClassIndex] = item;
          this.showSelectField = "";
          this.activeClassIndex = -1;
        }
      } else {
        if (this.addStatsData?.selected_fields) {
          this.addStatsData.selected_fields.push(item);
        } else {
          this.addStatsData["selected_fields"] = [item];
        }
        this.showSelectField = "";
      }
      this.refreshFormulaData();
    },
    addNumber() {
      if (this.activeClassIndex > -1) {
        let fieldData =
          this.addStatsData.selected_fields[this.activeClassIndex];
        if (
          fieldData.type == "FIELD" ||
          fieldData.type == "FORMULA" ||
          fieldData.type == "NUMBER" ||
          fieldData.type == "DATE" ||
          fieldData.type == "CURRENCY" ||
          fieldData.type == "TIME" ||
          fieldData.type == "LIST" ||
          fieldData.type == "GLOBAL_VARIABLE"
        ) {
          let number = this.manualNumber;
          this.addStatsData.selected_fields[this.activeClassIndex] = {
            type: fieldData.type == "DATE" ? "DATE" : "NUMBER",
            number,
          };
          this.manualNumber = "";
          this.activeClassIndex = -1;
        }
      } else {
        if (this.manualNumber > 0) {
          let number = this.manualNumber;
          if (this.addStatsData?.selected_fields) {
            this.addStatsData.selected_fields.push({
              type: "NUMBER",
              number,
            });
          } else {
            this.addStatsData["selected_fields"] = [
              {
                type: "NUMBER",
                number,
              },
            ];
          }
          this.manualNumber = "";
        }
      }
      this.refreshFormulaData();
    },
    checkDisabled(type, item = "") {
      if (
        type == "field" ||
        type == "number" ||
        type == "currency" ||
        type == "global_variable" ||
        type == "date" ||
        type == "time" ||
        type == "list"
      ) {
        if (
          this.addStatsData?.selected_fields &&
          this.addStatsData.selected_fields.length
        ) {
          if (this.activeClassIndex > -1) {
            let fieldData =
              this.addStatsData.selected_fields[this.activeClassIndex];
            if (
              fieldData &&
              (fieldData.type == "FIELD" ||
                fieldData.type == "NUMBER" ||
                fieldData.type == "DATE" ||
                fieldData.type == "TIME" ||
                fieldData.type == "LIST" ||
                fieldData.type == "CURRENCY" ||
                fieldData.type == "GLOBAL_VARIABLE" ||
                fieldData.type == "FORMULA")
            ) {
              return false;
            } else {
              return true;
            }
          } else {
            return (
              this.addStatsData.selected_fields[
                this.addStatsData.selected_fields.length - 1
              ].type == "FIELD" ||
              this.addStatsData.selected_fields[
                this.addStatsData.selected_fields.length - 1
              ].type == "NUMBER" ||
              this.addStatsData.selected_fields[
                this.addStatsData.selected_fields.length - 1
              ].type == "DATE" ||
              this.addStatsData.selected_fields[
                this.addStatsData.selected_fields.length - 1
              ].type == "TIME" ||
              this.addStatsData.selected_fields[
                this.addStatsData.selected_fields.length - 1
              ].type == "DATE_TIME_RANGE" ||
              this.addStatsData.selected_fields[
                this.addStatsData.selected_fields.length - 1
              ].type == "DATE_RANGE" ||
              this.addStatsData.selected_fields[
                this.addStatsData.selected_fields.length - 1
              ].type == "LIST" ||
              this.addStatsData.selected_fields[
                this.addStatsData.selected_fields.length - 1
              ].type == "GLOBAL_VARIABLE" ||
              this.addStatsData.selected_fields[
                this.addStatsData.selected_fields.length - 1
              ].type == "FORMULA" ||
              this.addStatsData.selected_fields[
                this.addStatsData.selected_fields.length - 1
              ].type == "CURRENCY" ||
              (this.addStatsData.selected_fields[
                this.addStatsData.selected_fields.length - 1
              ].type == "PARENTHESES" &&
                this.addStatsData.selected_fields[
                  this.addStatsData.selected_fields.length - 1
                ].parentheses == ")")
            );
          }
        }
        return false;
      } else if (type == "operator") {
        if (
          this.addStatsData?.selected_fields &&
          this.addStatsData.selected_fields.length
        ) {
          if (this.activeClassIndex > -1) {
            let fieldData =
              this.addStatsData.selected_fields[this.activeClassIndex];
            if (fieldData && fieldData.type == "OPERATOR") {
              return false;
            } else {
              return true;
            }
          } else {
            return (
              this.addStatsData.selected_fields[
                this.addStatsData.selected_fields.length - 1
              ].type == "OPERATOR" ||
              (this.addStatsData.selected_fields[
                this.addStatsData.selected_fields.length - 1
              ].type == "PARENTHESES" &&
                this.addStatsData.selected_fields[
                  this.addStatsData.selected_fields.length - 1
                ].parentheses == "(")
            );
          }
        }
        return true;
      } else if (type == "parentheses") {
        if (this.activeClassIndex > -1) {
          return true;
        } else {
          let openParenthesesCount = 0;
          let lastOpenIndex = -1;
          let closeParenthesesCount = 0;
          let selectedFieldsLength =
            this.addStatsData &&
            this.addStatsData.selected_fields &&
            this.addStatsData.selected_fields.length
              ? this.addStatsData.selected_fields.length
              : 0;
          let index = -1;
          (this.addStatsData.selected_fields || []).map((el) => {
            index += 1;
            if (el.type == "PARENTHESES") {
              if (el.parentheses == "(") {
                openParenthesesCount += 1;
                lastOpenIndex = index;
              } else {
                closeParenthesesCount += 1;
              }
              return;
            }
          });
          let afterLastOpenLength = selectedFieldsLength - (lastOpenIndex + 1);
          if (!selectedFieldsLength) {
            return item == ")";
          } else if (selectedFieldsLength < 3) {
            //condition for formula
            return (
              this.addStatsData.selected_fields[selectedFieldsLength - 1]
                .type != "OPERATOR" || item == ")"
            );
          } else {
            if (item == "(") {
              if (
                this.addStatsData.selected_fields[selectedFieldsLength - 1]
                  .type == "OPERATOR"
              ) {
                return false;
              } else if (
                this.addStatsData.selected_fields[selectedFieldsLength - 1]
                  .type == "PARENTHESES" &&
                this.addStatsData.selected_fields[selectedFieldsLength - 1]
                  .parentheses == "("
              ) {
                return false;
              } else {
                return true;
              }
            } else {
              if (
                this.addStatsData.selected_fields[selectedFieldsLength - 1]
                  .type == "OPERATOR"
              ) {
                return true;
              } else if (openParenthesesCount <= closeParenthesesCount) {
                return true;
              } else if (afterLastOpenLength < 2) {
                return true;
              } else if (
                afterLastOpenLength > 2 &&
                afterLastOpenLength % 2 == 0
              ) {
                if (
                  this.addStatsData.selected_fields[selectedFieldsLength - 1]
                    .type == "PARENTHESES" &&
                  this.addStatsData.selected_fields[selectedFieldsLength - 1]
                    .parentheses == ")"
                ) {
                  return false;
                }
                return true;
              } else {
                return false;
              }
            }
          }
        }
      } else {
        return false;
      }
    },
    onSelectOperator(operator) {
      if (
        this.activeClassIndex > -1 &&
        this.addStatsData.selected_fields[this.activeClassIndex].type ==
          "OPERATOR"
      ) {
        this.addStatsData.selected_fields[this.activeClassIndex] = {
          type: "OPERATOR",
          operator,
        };
        this.showSelectOperator = "";
        this.activeClassIndex = -1;
      } else {
        this.addStatsData.selected_fields.push({ type: "OPERATOR", operator });
        this.showSelectOperator = "";
      }
      this.refreshFormulaData();
    },
    getOperationType(operator) {
      if (operator == "+") {
        return "success";
      } else if (operator == "-") {
        return "primary";
      } else if (operator == "*") {
        return "info";
      } else if (operator == "/") {
        return "warning";
      }
    },
    getActiveClass(index) {
      if (this.activeClassIndex == index) {
        return "active";
      }
    },
    swapFields(index) {
      if (this.activeClassIndex > -1) {
        this.activeClassIndex = -1;
      } else {
        this.activeClassIndex = index;
      }
    },
    showFieldButton(type) {
      if (
        type == "FIELD" ||
        type == "NUMBER" ||
        type == "TIME" ||
        type == "DATE_TIME_RANGE" ||
        type == "DATE_RANGE" ||
        type == "LIST" ||
        type == "DATE" ||
        type == "CURRENCY" ||
        type == "GLOBAL_VARIABLE" ||
        type == "FORMULA"
      ) {
        return true;
      } else {
        return false;
      }
    },
    handleClose(index) {
      this.addStatsData.table_field_group_by_fields.splice(index, 1);
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    resetModal() {
      this.openTableColumsModal = false;
    },
    saveTableGroupBy() {
      this.addStatsData.table_field_group_by_fields = [];
      this.addStatsData.table_field_group_by_fields = [
        ...this.tableFieldGroupByFieldsModal,
      ];
      this.openTableColumsModal = false;
    },
    fillLabel(key, index) {
      if (key) {
        if (key == "count") {
          this.tableFieldGroupByFieldsModal[index]["name"] = "Count";
        } else {
          let field = this.getTotalFields.find((e) => e.key == key);
          this.tableFieldGroupByFieldsModal[index]["name"] =
            field && field.label ? field.label : "";
        }
      }
    },
    addNewColumn() {
      this.tableFieldGroupByFieldsModal.push({
        name: "",
        key: "",
      });
    },
    openTableColums() {
      this.tableFieldGroupByFieldsModal = [];
      this.tableFieldGroupByFieldsModal = [
        ...this.addStatsData.table_field_group_by_fields,
      ];
      this.openTableColumsModal = true;
    },
    getParentPath(selectedCategory) {
      if (selectedCategory == "default" || !selectedCategory) {
        if (this.iconColor == "White") {
          return "menuApplicationUsers" + "White";
        } else {
          return "menuApplicationUsers";
        }
      } else {
        if (this.iconColor == "White") {
          return selectedCategory + "-" + "White";
        } else {
          return selectedCategory + "-" + "black";
        }
      }
    },
    getFieldType(key) {
      let selectedField = this.getTemplateFields.find((e) => e.key == key);
      let currencyIncluded = (selectedField?.selected_fields || []).find(
        (e) => e?.validations?.currency || e.currency_type
      );
      let formulaCurrecy = (selectedField?.selected_fields || []).find((e) => {
        if (e?.input_type == "FORMULA" && e?.result_type == "CURRENCY") {
          let fc = (e?.selected_fields || []).find(
            (e) => e?.currency_type || e.input_type == "CURRENCY"
          );
          this.addStatsData.currency_type = fc?.currency_type;
          return fc;
        }
      });
      if (
        selectedField &&
        (selectedField.inputType == "CURRENCY" ||
          (selectedField.inputType == "AGGREGATE_FUNCTION" &&
            (currencyIncluded || selectedField?.validations?.currency)) ||
          ((selectedField.result_type == "NUMBER" ||
            selectedField.result_type == "CURRENCY") &&
            selectedField.inputType == "FORMULA" &&
            (currencyIncluded || selectedField?.validations?.currency))) &&
        (this.addStatsData.display_type == "sum" ||
          this.addStatsData.display_type == "avg" ||
          this.addStatsData.display_type == "count_and_sum")
      ) {
        this.addStatsData.is_currency = true;
        if (selectedField.validations && selectedField.validations.currency) {
          this.addStatsData.currency_type =
            selectedField.validations.currency || "USD";
        } else if (selectedField?.selected_fields?.[0]?.validations?.currency) {
          this.addStatsData.currency_type =
            selectedField.selected_fields[0].validations.currency || "USD";
        } else if (currencyIncluded) {
          this.addStatsData.currency_type = currencyIncluded || "USD";
        }
      } else if (
        selectedField?.inputType == "AGGREGATE_FUNCTION" &&
        formulaCurrecy
      ) {
        this.addStatsData.is_currency = true;
      } else {
        this.addStatsData.is_currency = false;
      }
    },
    async showNumberFields() {
      // if (this.addStatsData.display_type == "sum") {
      await this.fetchTemplateFields(true, true);
      // }
    },
    async fetchTemplateFields(reset, isStat = false) {
      if (!this.addStatsData.entity_id) {
        return;
      }
      // const entity = (this.getAllEntities?.data || []).find(
      //   (e) => e._id == this.addStatsData.entity_id
      // );
      const entity = await fetchEntityById(this.addStatsData.entity_id);
      const templateIds = (entity?.templates || [])
        .filter((e) => !e.is_repeatable)
        .flatMap((e) => e.template_id);
      let entityTemplates = [];
      if (entity?.templates) {
        entityTemplates = (entity.templates || [])
          .filter((e) => {
            let tid =
              e.template_id && e.template_id._id
                ? e.template_id._id
                : e.template_id;
            return templateIds.indexOf(tid) !== -1;
          })
          .flatMap((e) => e.templateInfo || e.template_id);
      } else {
        entityTemplates = (
          this.getAllCompanyTemplatesData &&
          this.getAllCompanyTemplatesData.data
            ? this.getAllCompanyTemplatesData.data
            : []
        ).filter((e) => templateIds.indexOf(e._id) !== -1);
      }
      if (reset) {
        this.addStatsData.pie_chart_field = "";
      }
      this.getTemplateFields = [];
      this.getAllDateFields = [];
      this.getTotalFields = [];
      this.getAllFields = [];
      entityTemplates.forEach((e) => {
        let data = JSON.parse(JSON.stringify(e));
        let data1 = JSON.parse(JSON.stringify(e));
        let customization =
          entity.templates.find((t) => t.template_id == e._id)?.customization ||
          {};
        if (customization) {
          data.sections[0].fields = this.applyCustomizationOnFields(
            data.sections[0].fields,
            customization
          );
          data1.sections[0].fields = this.applyCustomizationOnFields(
            data1.sections[0].fields,
            customization
          );
        }
        this.getAllDateFields = [
          ...this.getAllDateFields,
          ...this.getTemplateFieldsByType(data1, [
            "DATE",
            "DATE_TIME",
            "DATE_RANGE",
          ]),
        ];

        let types = [];
        if (isStat) {
          types = ["NUMBER", "CURRENCY", "FORMULA", "AGGREGATE_FUNCTION"];
        } else {
          types = [
            "SELECT",
            "YES_OR_NO",
            "MULTI_SELECT",
            "ENTITY",
            "DATE",
            "WEEKDAYS",
          ];
        }
        if (this.addStatsData.display_type == "MISSING_SLOTS") {
          types = [...types, ...["LIST", "DATE", "ENTITY"]];
        }
        this.getTemplateFields = [
          ...this.getTemplateFields,
          ...this.getTemplateFieldsByType(data, types),
        ];
        this.getTotalFields = [
          ...this.getTotalFields,
          ...this.getTemplateFieldsByType(data1, [
            "NUMBER",
            "CURRENCY",
            "AGGREGATE_FUNCTION",
          ]),
        ];
        this.getAllFields = [
          ...this.getAllFields,
          ...this.getTemplateFieldsByType(data, []),
        ];
      });
    },
    getTemplateFieldsByType(data, types) {
      let fields = [];
      data.sections.forEach((e) => {
        fields = [...fields, ...e.fields];
      });
      if (types && types.length) {
        fields = fields.filter(
          (e) =>
            types.indexOf(e.inputType) !== -1 ||
            (e.inputType == "FORMULA" && types.indexOf(e.result_type) !== -1)
        );
      }
      fields = fields
        .filter((fd) => fd.type != "CONTENT")
        .map((e) => {
          e.template_id = data._id;
          if (e.key && !e.key.includes("#")) {
            e.key = data._id + "#" + e.key;
          }
          e.template_name = data.name;
          e.data_type =
            e.validations && e.validations.type ? e.validations.type : "STRING";
          return e;
        });
      return fields;
    },
    setIconPath(name) {
      this.addStatsData.icon = name;
      this.iconPickerdialogVisible = false;
    },
    setIcon(icon) {
      this.addStatsData.icon = icon.url;
      this.addStatsData.icon_category = this.selectedCategory;
      this.iconPickerdialogVisible = false;
    },
    async getComponentInfo() {
      this.resetFormData();
      this.resetTableFormData();
      if (this.addStatsData.type == "CHART") {
        await this.fetchTemplateFields(true);
      } else {
        this.fetchAllEntityFilters(true);
      }
      if (
        this.addStatsData?.display_type == "MISSING_SLOTS" &&
        this.addStatsData?.entity_id
      ) {
        this.fetchRelatedEntities(this.addStatsData.entity_id);
      }
    },
    async fetchRelatedEntities(value) {
      this.otherEntitiesLoading = true;
      this.getEntityFieldRelatedEntities = [];
      let response = await postAPICall("GET", `/entities/related/${value}`);
      this.getEntityFieldRelatedEntities = response?.data || [];
      this.otherEntitiesLoading = false;
      if (this.addStatsData?.other_entity_id) {
        this.getOtherEntityFields();
      }
    },
    resetFormData() {
      this.addStatsData.chart_type = "";
      this.addStatsData.pie_chart_field = "";
      this.addStatsData.chart_selected_filter = "";
      this.addStatsData.pie_chart_field_group_by = "";
      this.addStatsData.pie_chart_field_group_by_selected_options = "";
      this.addStatsData.sum_fields = "";
      this.addStatsData.filter_id = "";
      this.addStatsData.global_filters = true;
      // this.addStatsData.show_data_in_table = false;
      this.addStatsData.send_notification = false;
    },
    resetTableFormData() {
      this.addStatsData.table_field_group_by = "";
      this.addStatsData.table_field_sub_group_by = "";
    },
    async fetchAllEntityFilters(reset) {
      this.modalLoading = true;
      if (this.selectedEntityRelationalData) {
        this.addStatsData.is_nested_relational_data = false;
        this.addStatsData.is_relational_data = true;
        this.addStatsData.entity_id = this.selectedEntityRelationalData;
      } else if (this.selectedEntityNestedRelationalData) {
        this.addStatsData.is_relational_data = false;
        this.addStatsData.is_nested_relational_data = true;
        this.addStatsData.entity_id =
          this.selectedEntityNestedRelationalData.split("#")[1];
        this.addStatsData.selectedEntityNestedRelationalData =
          this.selectedEntityNestedRelationalData;
      } else {
        this.addStatsData.is_relational_data = false;
        this.addStatsData.is_nested_relational_data = false;
        this.selectedEntityRelationalData = "";
        this.selectedEntityNestedRelationalData = "";
      }
      // await this.$store.dispatch("filters/fetchAllEntityFilters", {
      //   entityId: this.addStatsData.entity_id,
      // });
      const getAllEntityFilters = await fetchAllEntityFiltersByEntity({
        entityId: this.addStatsData.entity_id,
      });

      this.statEntityFilters = [];
      this.chartFilters = [];
      if (reset) {
        this.getTemplateFields = [];
        this.getAllFields = [];
        this.addStatsData.filter_id = "";
        this.addStatsData.sum_field = "";
        await this.showNumberFields();
      }
      if (getAllEntityFilters) {
        this.statEntityFilters = [...getAllEntityFilters];
      }
      this.chartFilters = getAllEntityFilters;
      if (this.addStatsData.type == "STAT") {
        if (
          this.addStatsData.display_type == "sum" ||
          this.addStatsData.display_type == "count_and_sum" ||
          this.addStatsData.display_type == "avg" ||
          this.addStatsData.display_type == "MISSING_SLOTS"
        ) {
          await this.fetchTemplateFields(true, true);
        } else {
          await this.fetchTemplateFields(reset);
        }
      }
      this.modalLoading = false;
    },
    removeRow(index) {
      if (this.rows.length > 1) {
        this.rows.splice(index, 1);
      }
    },
    addRow() {
      this.addStatsData.combinedData = this.rows;
      this.rows.push({ sum_field: null, chart_type: null });
    },
    isOptionDisabled(selectedField, fieldKey, rowIndex) {
      for (let i = 0; i < rowIndex; i++) {
        if (this.rows[i].sum_field === fieldKey) {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    tableData: {
      handler(newTableData) {
        newTableData.forEach(async (row, index) => {
          if (row.entityId) {
            this.$set(this.tableData[index], "customizations", []);
            const customizations = await this.getEntityCustomizations(
              row.entityId
            );
            this.$set(
              this.tableData[index],
              "customizations",
              customizations?.data || []
            );
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.main-form {
  display: flex;
  flex-direction: column;
}

.formula-dialog .form-right .artboard .btn-variable {
  margin-top: 5px !important;
}

.artboard {
  flex-wrap: wrap !important;
}

.artboard {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #d2d2d2;
  border-radius: 0px;
  padding: 0.5em 1em 0.25em;
  min-height: 60px;
  display: flex;
  align-items: center;
  overflow: scroll;
  width: 100%;
  background: #ffffff;

  .el-tag {
    margin-left: 0.5em;
  }

  .btn-variable {
    background-color: #000577;
    border-radius: 30px;
    color: #ffffff;
    border: #000577;
    padding: 10px 35px 10px 15px;
    position: relative;

    &.active {
      background-color: #dd5050 !important;
      box-shadow: 0 0 0 4px #efefef;
    }

    &:hover {
      box-shadow: 0 0 0 4px #f7f7f7;
    }

    img {
      position: absolute;
      top: 7px;
      right: 7px;
      width: 20px;
      height: 20px;
      opacity: 0.7;
    }

    &:hover {
      img {
        opacity: 1;
      }
    }
  }

  .btn-operation {
    display: flex;
    align-items: center;
    margin: 0 5px;
    padding: 5px 6px;

    img {
      max-width: 15px;
    }

    &.active {
      border: 2px solid #ff3e3e !important;
      background-color: #f34423 !important;
    }
  }

  .text-button {
    font-size: 4em;
    line-height: 15px;

    span {
      position: relative;
      margin-top: -9px;
      display: block;
      color: #c4c4c4;
    }
  }

  .el-button + .el-button {
    margin: 0 5px;
  }
}

.circle-icon-CD {
  width: 45px;
  height: 43px;
  border-radius: 50%;
  text-align: center;
  margin-top: 10px;
}

.icon-sty {
  margin-top: 8px !important;
}

.circle-icon {
  width: 45px;
  height: 43px;
  border-radius: 50%;
  text-align: center;
  //line-height: 100px;
  //vertical-align: middle;
  margin-top: 10px;
}

// .icon-img-style {
//   margin-top: 10px !important;
//   margin-right: 2px !important;
// }

.operaters {
  text-align: center;
  margin-top: 1em;

  img {
    max-width: 25px;
  }
}

.brackets-btn-group {
  margin-left: 2em;

  .el-button {
    font-size: 2em;
  }
}

.iconslistScrollable {
  padding: 1em;
}

.el-radio:last-child {
  position: relative;
  right: 14px;
}
</style>
